<template>
	<div class="container">
		<nav aria-label="breadcrumb">
			<ol class="breadcrumb">
				<router-link :to="{ name: 'PCReDive' }" tag="li" class="breadcrumb-item">
					<a href="#">{{ $t("HomeMenu") }}</a>
				</router-link>
				<router-link :to="{ name: 'Armory' }" tag="li" class="breadcrumb-item">
					<a href="#">{{ $t("ArmoryMenu") }}</a>
				</router-link>
			</ol>
		</nav>
		<!-- Modal -->
		<div class="modal fade" id="ExportOk" tabindex="-1" role="dialog" aria-labelledby="ExportOkLabel" aria-hidden="true">
			<div class="modal-dialog modal-xl" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="ExportOkLabel">{{ $t("ExportTeam") }}</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<div class="">
							<button id="ExportBtn" class="pcbtn mb-3 mr-3" @click="exportUrl()">{{ $t("ExportUrl") }}</button>
							<button id="ExportTextBtn" class="pcbtn mb-3" @click="exportText()">{{ $t("ExportTxt") }}</button>
						</div>
						<div v-if="exportNotice != ''" class="mb-3">
							<input onclick="this.select();" class="input-group" type="text" v-model="exportNotice" />
							<br />
							{{ $t("ExportNotice") }}<br />
						</div>
						<div v-if="lzw != ''" style="font-family: Arial;word-break: break-all">
							<textarea id="ExportTxt" class="form-control" rows="20" onclick="this.select();">{{ lzw }}</textarea>
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="pcbtn" data-dismiss="modal">{{ $t("Close") }}</button>
					</div>
				</div>
			</div>
		</div>
		<!-- Modal -->
		<div class="modal fade" id="ImportModal" tabindex="-1" role="dialog" aria-labelledby="ImportModalLabel" aria-hidden="true">
			<div class="modal-dialog modal-xl" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="ImportModalLabel">{{ $t("ImportText") }}</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<textarea class="form-control" rows="20" v-model="importTxt"></textarea>
					</div>
					<div class="modal-footer">
						<button class="pcbtn primary my-3" @click="importText">{{ $t("Import") }}</button>
						<button type="button" class="pcbtn" data-dismiss="modal">{{ $t("Close") }}</button>
					</div>
				</div>
			</div>
		</div>
		<div class="modal fade" id="FastChangeCaption" tabindex="-1" role="dialog" aria-labelledby="FastChangeCaptionLabel" aria-hidden="true">
			<div class="modal-dialog" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="FastChangeCaptionLabel">{{ $t("Caption") }}</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<h4 class="item-sub-title">{{ $t("FastEditCaption") }}</h4>
						點選快速修改按鈕開啟快速修改道具欄庫存的輸入欄<br />
						輸入完成後<span class="font-red error">按下 Enter↵ 鍵或離開輸入框</span>觸發修改 <br />
						修改完成後會因需求總量不同而不在輸入前的位置。<br />
						Fast edit current item. Trigger by enter or blur input box.
						<br />
						<h4 class="item-sub-title mt-3">加法說明</h4>
						點選加法按鈕開啟加法道具欄庫存的輸入欄<br />
						輸入完成後<span class="font-red error">按下 Enter↵ 鍵或離開輸入框</span>觸發修改 <br />
						修改完成後會因需求總量不同而不在輸入前的位置。<br />
						Fast item addition. Trigger by enter or blur input box.
						<br />
						<h4 class="item-sub-title mt-3">額外掉落說明</h4>
						37章之後新增額外的必掉落<br />
						點選按鈕顯示必掉落清單。<br />
						Show map extra drop from area 37.
					</div>
					<div class="modal-footer">
						<button type="button" class="pcbtn" data-dismiss="modal">{{ $t("Close") }}</button>
					</div>
				</div>
			</div>
		</div>
		<div class="modal fade" id="SyncEq" tabindex="-1" role="dialog" aria-labelledby="SyncEqLabel" aria-hidden="true">
			<div class="modal-dialog" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="SyncEqLabel">{{ $t("FixEquipment") }}</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						{{ $t("SyncEquipmentCaption") }}<br />
						<button class="pcbtn primary my-3" @click="SyncEquipment(1)">{{ $t("SyncEquipment") }}</button>
					</div>
					<div class="modal-footer">
						<button type="button" class="pcbtn" data-dismiss="modal">{{ $t("Close") }}</button>
					</div>
				</div>
			</div>
		</div>
		<div class="modal fade" id="popBox" tabindex="-1" role="dialog" aria-labelledby="popBoxLabel" aria-hidden="true">
			<div class="modal-dialog" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="popBoxLabel">{{ popMsg.title }}</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						{{ popMsg.content }}
					</div>
					<div class="modal-footer">
						<button type="button" class="pcbtn" data-dismiss="modal">{{ $t("Close") }}</button>
					</div>
				</div>
			</div>
		</div>
		<div class="modal fade" id="LoadSlotTeam" tabindex="-1" role="dialog" aria-labelledby="LoadSlotTeamLabel" aria-hidden="true">
			<div class="modal-dialog" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="LoadSlotTeamLabel">{{ $t("Load") }} {{ tempSlotData.name }}</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<div class="form-group row">
							<div class="col-7">
								<input type="text" class="form-control" :value="tempSlotData.name" ref="SlotName" />
							</div>
							<label class="col-5 col-form-label">
								<span style="margin-bottom:-5px" class="d-inline-block">
									修改名稱 <i id="editSlot" @click="editSlotName" class="icon-custom edit pointer-curse float-right ml-3"></i>
								</span>
							</label>
						</div>
						{{ $t("LoadSlotTeamCaption") }}
					</div>
					<div class="modal-footer">
						<button type="button" class="pcbtn" data-dismiss="modal">{{ $t("Close") }}</button>
						<button type="button" class="pcbtn danger" data-dismiss="modal" @click="loadSlotTeam">{{ $t("Load") }}</button>
					</div>
				</div>
			</div>
		</div>
		<div class="modal fade" id="LoadTempTeam" tabindex="-1" role="dialog" aria-labelledby="LoadTempTeamLabel" aria-hidden="true">
			<div class="modal-dialog" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="LoadTempTeamLabel">{{ $t("Load") }}</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						{{ $t("LoadTempTeamCaption") }}
					</div>
					<div class="modal-footer">
						<button type="button" class="pcbtn" data-dismiss="modal">{{ $t("Close") }}</button>
						<button type="button" class="pcbtn danger" data-dismiss="modal" @click="loadTempTeam">{{ $t("Load") }}</button>
					</div>
				</div>
			</div>
		</div>
		<div class="modal fade" id="DeleteOk" tabindex="-1" role="dialog" aria-labelledby="DeleteOkLabel" aria-hidden="true">
			<div class="modal-dialog" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="DeleteOkLabel">{{ $t("DeleteTeam") }}</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						{{ $t("DeleteTeamCaption") }}
					</div>
					<div class="modal-footer">
						<button type="button" class="pcbtn" data-dismiss="modal">{{ $t("Close") }}</button>
						<button type="button" class="pcbtn danger" data-dismiss="modal" @click="deleteTeam">{{ $t("Delete") }}</button>
					</div>
				</div>
			</div>
		</div>
		<div class="modal fade" id="AddItemBox" tabindex="-1" role="dialog" aria-labelledby="AddItemBoxLabel" aria-hidden="true">
			<div class="modal-dialog modal-dialog-centered modal-lg " role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="AddItemBoxLabel">{{ $t("EquipmentList") }}</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<div class="itemBox col p-2" v-for="item in myItemList" :key="item.equipment_id">
							<template v-if="editItemOrder">
								<div class="little-mark" @click="itemDisable(item)" v-if="item.active == 1">
									<span class="icon-custom minus"></span>
								</div>
								<div class="little-mark" @click="itemDisable(item)" v-else>
									<span class="icon-custom"></span>
								</div>
							</template>
							<img style="width: 80px" v-lazy="'/static/images/equipment/icon_equipment_' + item.equipment_id + '.png'" :alt="getEqName(item.equipment_id)" :title="getEqName(item.equipment_id)" />
							<input class="form-control" style="width: 80px" type="number" value="0" v-model.number="item.count" />
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="pcbtn" data-dismiss="modal">{{ $t("Close") }}</button>
					</div>
				</div>
			</div>
		</div>
		<div class="modal fade" id="MapItemBox" tabindex="-1" role="dialog" aria-labelledby="MapItemBoxLabel" aria-hidden="true">
			<div class="modal-dialog modal-dialog-centered modal-xl" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="MapItemBoxLabel">
							{{ mapTarget.quest_name }}
						</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body mapDrop-table">
						<div class="d-flex flex-nowrap justify-content-center">
							<div v-for="(item, index) in mapTarget.quest_drop_item_list" class="p-2 text-center mapDrop-item mr-2">
								<img width="70" :title="item.reward_name" class="aligncenter" v-lazy="'/static/images/equipment/icon_equipment_' + item.reward_id + '.png'" :style="item.mapCount == '0' ? 'opacity: 0.5' : ''" />
								<span class="text-center py-1 d-block">
									{{ item.mapCount ? item.mapCount : item.overflow }}
								</span>
								<input type="number" class="form-control mb-1 inputStock" v-model="item.stock" onclick="this.select();" />
								<input type="number" style="border: 2px solid #f55291" class="form-control mb-1 inputStock" v-model="item.plus" onclick="this.select();" />
							</div>
						</div>
						<div class="d-flex flex-wrap justify-content-center my-1">
							<div v-for="(item, index) in mapTarget.subDropItemList" class="p-2 text-center mapDrop-item m-2">
								<img width="70" class="aligncenter" v-lazy="'/static/images/equipment/icon_equipment_' + item.eq_id + '.png'" :style="item.mapCount == '0' ? 'opacity: 0.5' : ''" />
								<span class="text-center py-1 d-block">
									{{ item.mapCount ? item.mapCount : item.overflow }}
								</span>
								<input type="number" class="form-control mb-1 inputStock" v-model="item.stock" onclick="this.select();" />
								<input type="number" style="border: 2px solid #f55291" class="form-control mb-1 inputStock" v-model="item.plus" onclick="this.select();" />
							</div>
						</div>
						<p>
							{{ $t("MapDropCaption1") }}<br />
							{{ $t("MapDropCaption2") }}<br />
							{{ $t("MapDropCaption3") }}<br />
						</p>
					</div>
					<div class="modal-footer">
						<button type="button" class="pcbtn mr-3" @click="updateMap()">{{ $t("EditMap") }}</button>
						<button type="button" class="pcbtn" data-dismiss="modal">{{ $t("Close") }}</button>
					</div>
				</div>
			</div>
		</div>
		<div class="modal fade" id="AddCharacter" tabindex="-1" role="dialog" aria-labelledby="AddCharacterTitle" aria-hidden="true">
			<div class="modal-dialog modal-xl" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="AddCharacterTitle">
							{{ $t("AddCharacter") }}
						</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<div class="item-box">
							<div class="d-flex flex-wrap mb-3">
								<button type="button" class="pcbtn primary" @click="showAddUnitName = !showAddUnitName">
									{{ $t("show_name") }}
								</button>
							</div>
							<input type="text" class="form-control search-btn mb-3" placeholder="Search" aria-label="Search for..." v-on:input="debounceInput" />
							<div v-for="n in 3">
								<div class="d-flex flex-wrap mb-3">
									<div class="p-1 m-1 armory-box" v-for="(item, index) in $data['star' + backward(n)]" :value="item" v-if="item.select == false && item.show == true" :class="showAddUnitName ? 'armory-box-show-name' : ''" :key="item.id">
										<div class="armory-img-box gacha-item" :class="checkStar(item.rarity)" @click="joinTeam(item.id, index, item.rarity)">
											<img v-lazy="'/static/images/unit/icon_unit_' + (Number(item.unit_id) + 30) + '.png'" alt="" />
											<div class="star-box">
												<span v-for="n in 5" class="rarity">
													<img src="/static/images/star.png" v-if="n <= Number(item.rarity)" />
													<img src="/static/images/star_dark.png" v-else />
												</span>
											</div>
										</div>
										<div class="" v-if="showAddUnitName">
											{{ getI18nName(item, "name") }}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="pcbtn" data-dismiss="modal">{{ $t("Close") }}</button>
					</div>
				</div>
			</div>
		</div>
		<div class="modal fade" id="AllCharacter" tabindex="-1" role="dialog" aria-labelledby="AllCharacterTitle" aria-hidden="true">
			<div class="modal-dialog modal-dialog-centered " role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="AllCharacterTitle">
							{{ $t("EditAllCaption") }}
						</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body armory-bg">
						<div class="armory-unit">
							<div class="equipment">
								<div class="row">
									<div class="col-6 mb-3" :class="leftOrRight(index)" v-for="(item, index, key) in rankAll.rList">
										<span class="eq-box" @click="rankAllActive(index)">
											<img v-if="!item.active" width="80" class="add" v-lazy="'/static/images/add.png'" />
											<img width="80" class="img-fluid" v-lazy="'/static/images/equipment/icon_equipment_999999.png'" />
										</span>
									</div>
								</div>
							</div>
							<div class="info-box">
								<div class="row">
									<div class="col">
										<div class="form-group row">
											<label for="f1" class="col-sm-2 col-form-label col-form-label-sm">
												{{ $t("Equipment") }}
											</label>
											<div class="col-sm-10">
												<select class="form-control form-control-sm" v-model="rankAll.putEquipment">
													<option value="0">{{ $t("NoChange") }}</option>
													<option value="1">{{ $t("Change") }}</option>
												</select>
											</div>
										</div>
										<div class="form-group row">
											<label for="f1" class="col-sm-2 col-form-label col-form-label-sm">
												Rank
											</label>
											<div class="col-sm-10">
												<select class="form-control form-control-sm" v-model="rankAll.promotion_level">
													<option value="0">{{ $t("NoChange") }}</option>
													<option v-for="n in promotion_level_top" :value="n">{{ n }}</option>
												</select>
											</div>
										</div>
										<div class="form-group row">
											<label for="f2" class="col-sm-2 col-form-label col-form-label-sm">
												{{ $t("StarRank") }}
											</label>
											<div class="col-sm-10">
												<select class="form-control form-control-sm" v-model="rankAll.rarity" :value="rankAll.rarity">
													<option value="0">{{ $t("NoChange") }}</option>
													<option v-for="n in 6" :value="n">{{ n }}</option>
												</select>
											</div>
										</div>
										<div class="form-group row">
											<label for="f2" class="col-sm-2 col-form-label col-form-label-sm">
												{{ $t("UniqueEquipment") }}
											</label>
											<div class="col-sm-10">
												<select class="form-control form-control-sm" v-model="rankAll.uqEq" :value="rankAll.uqEq">
													<option value="0" selected="selected">{{ $t("NoChange") }}</option>
													<option value="310">310</option>
													<option value="300">300</option>
													<option value="290">290</option>
													<option value="280">280</option>
													<option value="270">270</option>
													<option value="260">260</option>
													<option value="250">250</option>
													<option value="240">240</option>
													<option value="230">230</option>
													<option value="220">220</option>
													<option value="210">210</option>
													<option value="200">200</option>
													<option value="190">190</option>
													<option value="180">180</option>
													<option value="170">170</option>
													<option value="160">160</option>
													<option value="150">150</option>
													<option value="140">140</option>
													<option value="130">130</option>
													<option value="110">110</option>
													<option value="90">90</option>
													<option value="70">70</option>
													<option value="50">50</option>
													<option value="30">30</option>
													<option value="1">1</option>
												</select>
											</div>
										</div>
										<div class="form-group row">
											<label for="f2" class="col-sm-2 col-form-label col-form-label-sm">
												{{ $t("Trace") }}
											</label>
											<div class="col-sm-10">
												<select class="form-control form-control-sm" v-model="rankAll.trace" :value="rankAll.trace">
													<option value="0">{{ $t("NoChange") }}</option>
													<option value="true">{{ $t("TraceTop") }}</option>
													<option value="false">{{ $t("TraceNone") }}</option>
													<option v-for="(option, index) in traceOption" :value="option.value">{{
														option.displayName
														}}</option>
												</select>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="modal-footer">
						<div class="row">
							<div class="col-12">
								<small>{{ $t("EditAllCaption1") }}</small>
								<br />
								<small>{{ $t("EditAllCaption2") }}</small>
							</div>
							<div class="col-12 text-right">
								<button type="button" class="pcbtn mr-3" data-dismiss="modal">
									{{ $t("Close") }}
								</button>
								<button type="button" class="pcbtn primary" @click="allCharaEdit()" data-dismiss="modal">
									{{ $t("EditAll") }}
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="modal fade" id="TargetCharacter" tabindex="-1" role="dialog" aria-labelledby="TargetCharacterTitle" aria-hidden="true">
			<div class="modal-dialog modal-dialog-centered modal-lg" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="TargetCharacterTitle">
							{{ $t("EditSelectionUnit") }}
						</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<div class="col">
							<div class="d-flex flex-wrap mb-3 armory-target-box">
								<div v-for="item in editTeamList" class="m-1 text-center">
									<img 
									:class="!item.active ? 'grayimg' : 'active'" 
									style="width: 70px;" 
									class="pointer-curse" 
									v-lazy="item.rarity == 6 ? '/static/images/unit/icon_unit_' + (Number(item.unit_id) + 60) + '.png' : '/static/images/unit/icon_unit_' + (Number(item.unit_id) + 30) + '.png'" 
									@click="activeEditList(item.unit_id)" />
									<br>
									Rank {{ item.promotion_level }}
								</div>								
							</div>
						</div>
					</div>
					<div class="modal-body armory-bg">
						<div class="armory-unit">
							<div class="equipment">
								<div class="row">
									<div class="col-6 mb-3" :class="leftOrRight(index)" v-for="(item, index, key) in rankTarget.rList">
										<span class="eq-box pointer-curse" @click="rankTargetActive(index)">
											<img v-if="!item.active" width="80" class="add" v-lazy="'/static/images/add.png'" />
											<img width="80" class="img-fluid" v-lazy="'/static/images/equipment/icon_equipment_999999.png'" />
										</span>
									</div>
								</div>
							</div>
							<div class="info-box">
								<div class="row">
									<div class="col">
										<div class="form-group row">
											<label for="f1" class="col-sm-2 col-form- label col-form-label-sm">
												{{ $t("Equipment") }}
											</label>
											<div class="col-sm-10">
												<select class="form-control form-control-sm" v-model="rankTarget.putEquipment">
													<option value="0">{{ $t("NoChange") }}</option>
													<option value="1">{{ $t("Change") }}</option>
												</select>
											</div>
										</div>
										<div class="form-group row">
											<label for="f1" class="col-sm-2 col-form-label col-form-label-sm">
												Rank
											</label>
											<div class="col-sm-10">
												<select class="form-control form-control-sm" v-model="rankTarget.promotion_level">
													<option value="0">{{ $t("NoChange") }}</option>
													<option v-for="n in promotion_level_top" :value="n">{{ n }}</option>
												</select>
											</div>
										</div>
										<div class="form-group row">
											<label for="f2" class="col-sm-2 col-form-label col-form-label-sm">
												{{ $t("StarRank") }}
											</label>
											<div class="col-sm-10">
												<select class="form-control form-control-sm" v-model="rankTarget.rarity" :value="rankTarget.rarity">
													<option value="0">{{ $t("NoChange") }}</option>
													<option v-for="n in 6" :value="n">{{ n }}</option>
												</select>
											</div>
										</div>
										<div class="form-group row">
											<label for="f2" class="col-sm-2 col-form-label col-form-label-sm">
												{{ $t("UniqueEquipment") }}
											</label>
											<div class="col-sm-10">
												<select class="form-control form-control-sm" v-model="rankTarget.uqEq" :value="rankTarget.uqEq">
													<option value="0" selected="selected">{{ $t("NoChange") }}</option>
													<option value="310">310</option>
													<option value="300">300</option>
													<option value="290">290</option>
													<option value="280">280</option>
													<option value="270">270</option>
													<option value="260">260</option>
													<option value="250">250</option>
													<option value="240">240</option>
													<option value="230">230</option>
													<option value="220">220</option>
													<option value="210">210</option>
													<option value="200">200</option>
													<option value="190">190</option>
													<option value="180">180</option>
													<option value="170">170</option>
													<option value="160">160</option>
													<option value="150">150</option>
													<option value="140">140</option>
													<option value="130">130</option>
													<option value="110">110</option>
													<option value="90">90</option>
													<option value="70">70</option>
													<option value="50">50</option>
													<option value="30">30</option>
													<option value="1">1</option>
												</select>
											</div>
										</div>
										<div class="form-group row">
											<label for="f2" class="col-sm-2 col-form-label col-form-label-sm">
												{{ $t("Trace") }}
											</label>
											<div class="col-sm-10">
												<select class="form-control form-control-sm" v-model="rankTarget.trace" :value="rankTarget.trace">
													<option value="0">{{ $t("NoChange") }}</option>
													<option value="true">{{ $t("TraceTop") }}</option>
													<option value="false">{{ $t("TraceNone") }}</option>
													<option v-for="(option, index) in traceOption" :value="option.value">{{
														option.displayName
														}}</option>
												</select>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="modal-footer">
						<div class="row">
							<div class="col-12 mb-3">
								<small>{{ $t("EditSelectionCaption1") }}</small>
							</div>
							<div class="col-12 text-right">
								<button type="button" class="pcbtn mr-3" data-dismiss="modal">
									{{ $t("Close") }}
								</button>
								<button type="button" class="pcbtn mr-3" @click="clearEditTarget()">
									{{ $t("Reset") }}
								</button>
								<button type="button" class="pcbtn primary" @click="targetRankTop()" data-dismiss="modal">
									{{ $t("EditSelectionUnit") }}
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 編輯角色 -->
		<div class="modal fade" id="SelectCharacter" tabindex="-1" role="dialog" aria-labelledby="SelectCharacterTitle" aria-hidden="true">
			<div class="modal-dialog modal-dialog-centered " role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="SelectCharacterTitle">
							{{ $t("EditCharacter") }}
						</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body armory-bg">
						<div class="armory-unit unit-bg-img" :style="getCharaImg(selectUnit.unit_id)">
							<div class="name">
								{{ getCharaName(selectUnit.unit_id) }}
							</div>
							<div class="equipment">								
								<div class="row">
									<div class="col-6 mb-3" :class="leftOrRight(index)" v-for="(item, index, key) in unit_equipment()">										
										<span class="eq-box" v-if="item.eq_id">
											<img width="80" src="/static/images/equipment/icon_equipment_999999.png" :class="checkUnitTrace(index)" />
											<img v-if="!item.active" width="80" class="add" @click="eqActive(item.eq_id, index)" v-lazy="'/static/images/add.png'" />
											<img width="80" @click="eqRemove(item.eq_id, index)" class="img-fluid" v-lazy="'/static/images/equipment/icon_equipment_' + item.eq_id + '.png'" />
										</span>
									</div>
								</div>
							</div>
							<div class="info-box">
								<div class="row">
									<div class="col-lg-3 col-12 text-center mb-3">
										<img class="unitImg" :src="'/static/images/unit/icon_unit_' + (Number(selectUnit.unit_id) + 30) + '.png'" alt="" />
									</div>
									<div class="col-lg-9 col-12">
										<div class="form-group row">
											<label for="f1" class="col-sm-3 col-form-label col-form-label-sm">
												Rank
											</label>
											<div class="col-sm-9">
												<select class="form-control form-control-sm" v-on:change="changeRank()" v-model="selectUnit.promotion_level">
													<option v-for="n in reverseKeys(promotion_level_top)" :value="n + 1">
														{{ n + 1 }}
													</option>
												</select>
											</div>
										</div>
										<div class="form-group row">
											<label for="f2" class="col-sm-3 col-form-label col-form-label-sm">
												{{ $t("StarRank") }}
											</label>
											<div class="col-sm-9">
												<select class="form-control form-control-sm" :change="changeRarity()" v-model="selectUnit.rarity" :value="selectUnit.rarity">
													<option v-for="n in 6" :value="n">{{ n }}</option>
												</select>
											</div>
										</div>
										<div class="form-group row">
											<label for="f2" class="col-sm-3 col-form-label col-form-label-sm">
												{{ $t("Track") }}
											</label>
											<div class="col-sm-9">
												<select class="form-control form-control-sm" v-model="selectUnit.trace" :value="selectUnit.trace">
													<option value="true">{{ $t("track_yes") }}</option>
													<option value="false">{{ $t("track_no") }}</option>
													<option v-for="(option, index) in traceOption" :value="option.value">{{
														option.displayName
														}}</option>
												</select>
											</div>
										</div>
										<div class="form-group row">
											<label for="f2" class="col-sm-3 col-form-label col-form-label-sm">
												{{ $t("UniqueEquipment") }} 1
											</label>
											<div class="col-sm-9">
												<select class="form-control form-control-sm" v-model="selectUnit.uqEq" :value="selectUnit.uqEq">
													<option value="0" selected="selected">{{ $t("none") }}</option>
													<option value="310">310</option>
													<option value="300">300</option>
													<option value="290">290</option>
													<option value="280">280</option>
													<option value="270">270</option>
													<option value="260">260</option>
													<option value="250">250</option>
													<option value="240">240</option>
													<option value="230">230</option>
													<option value="220">220</option>
													<option value="210">210</option>
													<option value="200">200</option>
													<option value="190">190</option>
													<option value="180">180</option>
													<option value="170">170</option>
													<option value="160">160</option>
													<option value="150">150</option>
													<option value="140">140</option>
													<option value="130">130</option>
													<option value="110">110</option>
													<option value="90">90</option>
													<option value="70">70</option>
													<option value="50">50</option>
													<option value="30">30</option>
													<option value="1">1</option>
												</select>
											</div>
										</div>
										<div class="form-group row">
											<label for="f2" class="col-sm-3 col-form-label col-form-label-sm">
												{{ $t("UniqueEquipment") }} 2
											</label>
											<div class="col-sm-9">
												<select class="form-control form-control-sm" v-model="selectUnit.uqEq2" :value="selectUnit.uqEq2">
													<option value="0" selected="selected">{{ $t("none") }}</option>													
													<option value="5">5</option>
													<option value="4">4</option>
													<option value="3">3</option>
													<option value="2">2</option>
													<option value="1">1</option>
												</select>
											</div>
										</div>
										<div class="form-group row">
											<label for="f2" class="col-sm-3 col-form-label col-form-label-sm">
												{{ $t("lv_break") }}
											</label>
											<div class="col-sm-9">
												<select class="form-control form-control-sm" v-model="selectUnit.lvBreak" :value="selectUnit.lvBreak">
													<option value="true">{{ $t("Yes") }}</option>
													<option value="false">{{ $t("No") }}</option>
												</select>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="modal-footer">
						<div class="row">
							<div class="col-12 mb-3">
								<small>如角色出現裝備資訊不符合或是沒有計算到裝備，請點選修復裝備按鈕。</small>
								<br />
								<small>還是沒有修正的話，請點選移除後再次加入。</small>
							</div>
							<div class="col-12 text-right">
								<button type="button" class="pcbtn danger mr-3" data-dismiss="modal" @click="deleteUnit(selectUnit.unit_id)">
									{{ $t("Remove") }}
								</button>
								<button type="button" class="pcbtn primary" data-dismiss="modal">
									{{ $t("Save") }}
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="item-box">
			<div class="mb-3" v-if="notSupport">
				<div class="alert alert-light" role="alert">
					{{ $t("NotSupport") }}
				</div>
			</div>
			<div class="row mb-3">
				<div class="col-lg-12 col-md-12 col-12 mb-3">
					<div class="row mb-1">
						<transition name="expand" @enter="enter" @after-enter="afterEnter" @leave="leave">
							<div class="col-12" v-if="saveSlotActive">
								<div class="d-flex flex-nowrap armory-function sticky-top">
									<div v-for="item in slotSetting">
										<button class="pcbtn mr-3" :key="item.id" @click="activeSlot(item)" :class="currentSlot == item.id ? 'active' : ''">
											{{ item.name }}
										</button>
									</div>
								</div>
							</div>
						</transition>
						<div class="col-12">
							<div class="d-flex flex-nowrap armory-function sticky-top">
								<button type="button" class="pcbtn" data-toggle="modal" data-target="#AddCharacter">
									{{ $t("AddCharacter") }}
								</button>
								<button type="button" data-toggle="modal" data-target="#AllCharacter" v-if="teamList.length > 0" class="pcbtn">
									{{ $t("EditAll") }}
								</button>
								<button type="button" data-toggle="modal" data-target="#TargetCharacter" v-if="teamList.length > 0" class="pcbtn" @click="getSelectTeamList()">
									{{ $t("EditSelection") }}
								</button>
								<!-- <button v-if="teamList.length > 0" data-toggle="modal" data-target="#SyncEq" class="pcbtn">
									{{$t('FixEquipment')}}
								</button> -->
								<button :class="exportActive ? 'active' : ''" class="pcbtn" @click="exportActive = !exportActive">
									{{ $t("ExportImport") }}
								</button>
								<!-- <button :class="saveSlotActive ? 'active':''" class="pcbtn" @click="saveSlotActive = !saveSlotActive">
									{{$t('SaveSlot')}}
								</button> -->
								<button v-if="teamList.length > 0" class="pcbtn primary" @click="saveTeam">
									{{ $t("SaveTeam") }}
								</button>
								<button v-if="teamList.length > 0" class="pcbtn danger" data-toggle="modal" data-target="#DeleteOk">
									{{ $t("DeleteTeam") }}
								</button>
							</div>
						</div>
						<transition name="expand" @enter="enter" @after-enter="afterEnter" @leave="leave">
							<div class="col-12" v-if="exportActive">
								<div class="d-flex flex-nowrap armory-function sticky-top">
									<button class="pcbtn primary" data-toggle="modal" data-target="#ImportModal">
										{{ $t("ImportTeam") }}
									</button>
									<button v-if="teamList.length > 0" data-toggle="modal" data-target="#ExportOk" class="pcbtn primary">
										{{ $t("ExportTeam") }}
									</button>
									<router-link :to="{ name: 'Resume' }" v-if="teamList.length > 0" tag="button" class="pcbtn primary">
										{{ $t("GenerateImage") }}
									</router-link>
								</div>
							</div>
						</transition>
					</div>
					<h3 class="item-title">
						<div class="row mb-3" v-if="teamList.length > 0">
							<div class="col-12 col-lg-6">
								{{ $t("MyTeam") }}
								<!-- {{slotName}} -->
							</div>
							<div class="col-12 col-lg-6"></div>
							<div class="col-12 mt-3">
								<div class="d-flex justify-content-between">
									<div>
										<button type="button" title="依照當前RANK等級來做排序" :class="filterPosition == 'rank' || filterPosition == '' ? 'active' : ''" @click="changeFilter('rank')" class="pcbtn mr-3 mb-3">
											{{ $t("Rank") }}
											<span v-if="filterPosition == 'rank'" :class="orderDesc ? 'down' : 'up'" class="icon-custom inline"></span>
										</button>
										<button type="button" title="依照角色站位來做排序" :class="filterPosition == 'search_area_width' ? 'active' : ''" @click="changeFilter('search_area_width')" class="pcbtn mr-3 mb-3">
											{{ $t("Distance") }}
											<span v-if="filterPosition == 'search_area_width'" :class="orderDesc ? 'down' : 'up'" class="icon-custom inline"></span>
										</button>
										<button type="button" title="依照角色當前星等來做排序" :class="filterPosition == 'star' ? 'active' : ''" @click="changeFilter('star')" class="pcbtn mr-3 mb-3">
											{{ $t("StarRank") }}
											<span v-if="filterPosition == 'star'" :class="orderDesc ? 'down' : 'up'" class="icon-custom inline"></span>
										</button>
										<button type="button" title="依照角色當前專用武器等級來做排序" :class="filterPosition == 'unique' ? 'active' : ''" @click="changeFilter('unique')" class="pcbtn mr-3 mb-3">
											{{ $t("UniqueEquipment") }}
											<span v-if="filterPosition == 'unique'" :class="orderDesc ? 'down' : 'up'" class="icon-custom inline"></span>
										</button>
										<button type="button" title="" :class="filterPosition == 'front' ? 'active' : ''" @click="changeFilter('front')" class="pcbtn mr-3 mb-3">
											{{ $t("FrontPosition") }}
											<span v-if="filterPosition == 'front'" :class="orderDesc ? 'down' : 'up'" class="icon-custom inline"></span>
										</button>
										<button type="button" title="" :class="filterPosition == 'middle' ? 'active' : ''" @click="changeFilter('middle')" class="pcbtn mr-3 mb-3">
											{{ $t("MiddlePosition") }}
											<span v-if="filterPosition == 'middle'" :class="orderDesc ? 'down' : 'up'" class="icon-custom inline"></span>
										</button>
										<button type="button" title="" :class="filterPosition == 'back' ? 'active' : ''" @click="changeFilter('back')" class="pcbtn mr-3 mb-3">
											{{ $t("BackPosition") }}
											<span v-if="filterPosition == 'back'" :class="orderDesc ? 'down' : 'up'" class="icon-custom inline"></span>
										</button>
									</div>
									<div>
										<button type="button" title="當角色裝備後自動減少庫存" v-if="teamList.length > 0" class="pcbtn mr-3 mb-3" @click="changeAutoSubtraction()" :class="{ active: autoSubtraction }">
											{{ $t("AutoReduce") }}
										</button>
										<button type="button" title="直接顯示角色當前的裝備" v-if="teamList.length > 0" class="pcbtn mr-3 mb-3" @click="showUnitEq()" :class="{ active: fastSee }">
											{{ $t("FastShow") }}
										</button>
									</div>
								</div>
							</div>
						</div>
					</h3>
					<!-- team-list-box 隊伍列表 -->
					<div class="d-flex flex-wrap mb-3 justify-content-lg-start justify-content-center" id="team-list-box">
						<template v-for="item in myList">
							<div :class="displayMode == 9 ? (item.focus ? '' : 'grayimg') : ''">
								<div class="p-1 d-block text-center" style="width: 90px" @click="item.focus = !item.focus" v-if="displayMode == 9">
									<input type="checkbox" v-model="item.focus" />
								</div>
								<div class="p-1 armory-box mb-1 armory-item-box" data-toggle="modal" data-target="#SelectCharacter" @click.prevent="selectCharacter(item)" :class="item.lvBreak == 'true' ? 'lv-break' : ''">									
									<div class="armory-img-box edit-box gacha-item" :class="checkPromo(item.promotion_level, item.trace)">
										<img v-lazy="'/static/images/unit/icon_unit_' + (Number(item.unit_id) + 10) + '.png'" alt="" v-if="item.rarity < 3" />
										<img v-else-if="item.rarity <= 5 && item.rarity >= 3" v-lazy="'/static/images/unit/icon_unit_' + (Number(item.unit_id) + 30) + '.png'" alt="" />
										<img v-else v-lazy="'/static/images/unit/icon_unit_' + (Number(item.unit_id) + 60) + '.png'" alt="" />
										<div class="star-box" v-if="item.rarity != '6'">
											<span v-for="n in 5" class="rarity">
												<img src="/static/images/star.png" v-if="n <= Number(item.rarity)" />
												<img src="/static/images/star_dark.png" v-else />
											</span>
										</div>
										<div class="star-box" v-else>
											<span class="rarity pink">
												<img src="/static/images/star_pink.png" width="15px" />
											</span>
										</div>
										<div class="uq-mark" v-if="item.uqEq > 0">											
											<img :src="item.uqEq2 > 0 ? '/static/images/uneq2.png': '/static/images/uneq.png'" />
										</div>
										<div class="uq-mark" style="top:0px;left: -15px">
											<span :class="'icon icon-ele t'+ getTalentId(item.unit_id)"></span>
										</div>
									</div>
									<div class="armory-detail-box" v-if="fastSee">
										<div class="row no-gutters">											
											<div class="col-6"> 
												<span class="armory-detail-img" :class="checkTraceClass(item.eqList[item.promotion_level - 1].equip_slot_1, item.trace, item.promotion_level, 'equip_slot_')">
													<img width="80" class="img-fluid" v-lazy="'/static/images/equipment/icon_equipment_' + item.eqList[item.promotion_level - 1].equip_slot_1.eq_id + '.png'" />
												</span>
											</div>
											<div class="col-6"> 
												<span class="armory-detail-img" :class="checkTraceClass(item.eqList[item.promotion_level - 1].equip_slot_2, item.trace, item.promotion_level, 'equip_slot_2')">
													<img width="80" class="img-fluid" v-lazy="'/static/images/equipment/icon_equipment_' + item.eqList[item.promotion_level - 1].equip_slot_2.eq_id + '.png'" />
												</span>
											</div>
											<div class="col-6"> 
												<span class="armory-detail-img" :class="checkTraceClass(item.eqList[item.promotion_level - 1].equip_slot_3, item.trace, item.promotion_level, 'equip_slot_3')">
													<img width="80" class="img-fluid" v-lazy="'/static/images/equipment/icon_equipment_' + item.eqList[item.promotion_level - 1].equip_slot_3.eq_id + '.png'" />
												</span>
											</div>
											<div class="col-6"> 
												<span class="armory-detail-img" :class="checkTraceClass(item.eqList[item.promotion_level - 1].equip_slot_4, item.trace, item.promotion_level, 'equip_slot_4')">
													<img width="80" class="img-fluid" v-lazy="'/static/images/equipment/icon_equipment_' + item.eqList[item.promotion_level - 1].equip_slot_4.eq_id + '.png'" />
												</span>
											</div>
											<div class="col-6"> 
												<span class="armory-detail-img" :class="checkTraceClass(item.eqList[item.promotion_level - 1].equip_slot_5, item.trace, item.promotion_level, 'equip_slot_5')">
													<img width="80" class="img-fluid" v-lazy="'/static/images/equipment/icon_equipment_' + item.eqList[item.promotion_level - 1].equip_slot_5.eq_id + '.png'" />
												</span>
											</div>
											<div class="col-6"> 
												<span class="armory-detail-img" :class="checkTraceClass(item.eqList[item.promotion_level - 1].equip_slot_6, item.trace, item.promotion_level, 'equip_slot_6')">
													<img width="80" class="img-fluid" v-lazy="'/static/images/equipment/icon_equipment_' + item.eqList[item.promotion_level - 1].equip_slot_6.eq_id + '.png'" />
												</span>
											</div>
											<!-- <div class="col-6" v-for="(eqItem, key, index) in item.eqList[item.promotion_level - 1]">
												<span class="armory-detail-img" v-if="eqItem.eq_id != null" :class="checkTraceClass(eqItem, item.trace, item.promotion_level, key)">
													<img width="80" class="img-fluid" v-lazy="'/static/images/equipment/icon_equipment_' + eqItem.eq_id + '.png'" />
												</span>
											</div> -->
										</div>
										<div class="text-center">R{{ item.promotion_level }}→{{ checkTrace(item.trace) }} <br /></div>
										<div class="text-center" v-if="item.uqEq">{{$t('UE')}}1: {{ item.uqEq }}<br /></div>
										<div class="text-center" v-if="item.uqEq2">{{$t('UE')}}2: {{ item.uqEq2 }}<br /></div>
									</div>
									<div class="text-center" v-else>Rank{{ item.promotion_level }}<br /></div>
								</div>
							</div>
						</template>
					</div>
				</div>
				<div class="col-12" v-if="teamList.length > 0">
					<div class="title-fixed-wrap">
						<h3 class="item-title">
							<div class="row">
								<div class="col-12 col-lg-12">
									<div class="d-flex flex-nowrap armory-function p-1 pb-3">
										<button class="pcbtn mr-3" title="顯示目前角色池缺少的裝備" @click="changeDisplayMode(1)" :class="this.displayMode == 1 ? 'active' : ''">
											{{ $t("EquipmentMode") }}
										</button>
										<button class="pcbtn mr-3" title="顯示目前角色池缺少的設計圖" @click="changeDisplayMode(2)" :class="this.displayMode == 2 ? 'active' : ''">
											{{ $t("RecipeMode") }}
										</button>
										<button class="pcbtn mr-3" title="依照缺少的裝備顯示建議地圖" @click="changeDisplayMode(3)" :class="this.displayMode == 3 ? 'active' : ''">
											{{ $t("MapDropMode") }}
										</button>
										<button class="pcbtn mr-3" title="依照缺少的裝備顯示建議地圖" @click="changeDisplayMode(9)" :class="this.displayMode == 9 ? 'active' : ''">
											{{ $t("FocusMode") }}
										</button>
										<button class="pcbtn mr-3" title="依照缺少的裝備顯示建議地圖" @click="changeDisplayMode(7)" :class="this.displayMode == 7 ? 'active' : ''">
											{{ $t("HVhMode") }}
										</button>
										<button type="button" class="pcbtn mr-3" @click="changeDisplayMode(8)" :class="this.displayMode == 8 ? 'active' : ''">
											{{ $t("ResourcesMode") }}
										</button>
										<button type="button" class="pcbtn mr-3" @click="changeDisplayMode(5)" :class="this.displayMode == 5 ? 'active' : ''">
											{{ $t("ItemBox") }}
										</button>
										<button type="button" class="pcbtn mr-3" @click="changeDisplayMode(6)" :class="this.displayMode == 6 ? 'active' : ''">
											{{ $t("Setting") }}
										</button>
									</div>
								</div>
								<div class="col-12 col-lg-12">
									<div class="d-flex flex-nowrap justify-content-start justify-content-md-start armory-function p-1" v-if="displayMode == 1">
										<button title="顯示銀色框的裝備" class="pcbtn mr-3" :class="{ active: ignoreEqRank }" @click="changeShowRank">
											{{ $t("IgnoreEqRank") }}
										</button>
										<button class="pcbtn mr-3" title="顯示缺此裝的角色" v-bind:class="{ active: eqDetail }" @click="showDetail">
											{{ $t("DetailList") }}
										</button>
									</div>
									<div class="d-flex flex-nowrap justify-content-start justify-content-md-start p-1" v-if="displayMode == 2">
										<button class="pcbtn mr-3" title="顯示銀色框的裝備" v-bind:class="{ active: ignoreEqRank }" @click="changeShowRank">
											{{ $t("IgnoreEqRank") }}
										</button>
										<button class="pcbtn mr-3" title="隱藏裝備庫存超出需求的裝備" v-bind:class="{ active: hiddenOverflow }" @click="showOverflow">
											{{ $t("HideOverFlow") }}
										</button>
										<button type="button" class="pcbtn mr-3" @click="isOldVersion()" :class="this.oldVersion ? 'active' : ''" title="Gear cost reduction from nnk pool to 4 year anniversary">
											{{ $t("4year_reduction") }}
										</button>
									</div>
									<div class="d-flex flex-nowrap justify-content-start justify-content-md-start p-1" v-if="displayMode == 3">
										<button class="pcbtn mr-3" @click="stopCalculate = !stopCalculate" :class="stopCalculate ? 'active' : ''">
											{{ $t("StopCalculate") }}
										</button>
										<button class="pcbtn mr-3" title="顯示銀色框的裝備" v-bind:class="{ active: ignoreEqRank }" @click="changeShowRank">
											{{ $t("IgnoreEqRank") }}
										</button>
										<button type="button" class="pcbtn mr-3" @click="isOldVersion()" :class="this.oldVersion ? 'active' : ''" title="Gear cost reduction from nnk pool to 4 year anniversary">
											{{ $t("4year_reduction") }}
										</button>
										<button type="button" class="pcbtn mr-3" @click="updateDropRate()" :class="this.dropRateUpdate ? 'active' : ''" title="Drop Rate Update">
											{{ $t("dropRateUpdate") }}
										</button>
										<button :class="filterEqActive ? 'active':''" class="pcbtn mr-3 " @click="filterEqActive = !filterEqActive">
											{{$t('FilterEquipmentList')}}
										</button>
										<button class="pcbtn" v-if="filterEqList.length > 0" @click="clearFilterEqList">
											{{$t('Clear')}}{{$t('FilterEquipmentList')}}
										</button>
									</div>
									<div class="d-flex flex-nowrap justify-content-start justify-content-md-start p-1" v-if="displayMode == 9">
										<button class="pcbtn mr-3" @click="stopCalculate = !stopCalculate" :class="stopCalculate ? 'active' : ''">
											{{ $t("StopCalculate") }}
										</button>
										<button class="pcbtn mr-3" title="顯示銀色框的裝備" v-bind:class="{ active: ignoreEqRank }" @click="changeShowRank">
											{{ $t("IgnoreEqRank") }}
										</button>
										<button type="button" class="pcbtn mr-3" @click="isOldVersion()" :class="this.oldVersion ? 'active' : ''" title="Gear cost reduction from nnk pool to 4 year anniversary">
											{{ $t("4year_reduction") }}
										</button>
										<button type="button" class="pcbtn mr-3" @click="updateDropRate()" :class="this.dropRateUpdate ? 'active' : ''" title="Drop Rate Update">
											{{ $t("dropRateUpdate") }}
										</button>
										<button :class="filterEqActive ? 'active':''" class="pcbtn mr-3 " @click="filterEqActive = !filterEqActive">
											{{$t('FilterEquipmentList')}}
										</button>
										<button class="pcbtn" v-if="filterEqList.length > 0" @click="clearFilterEqList">
											{{$t('Clear')}}{{$t('FilterEquipmentList')}}
										</button>
									</div>
								</div>
								<transition name="expand" @enter="enter" @after-enter="afterEnter" @leave="leave">
									<div class="col-12 mt-3" v-if="filterEqActive">
										<div class="d-flex flex-wrap justify-content-lg-start justify-content-center">
											<div class="card m-1 itemBox" v-for="item in myEqList" :key="item.eq_id" :style="isFiltered(item.eq_id) ?'opacity: 1;':'filter: opacity(50%);'">
												<div @click="addMapFilter(item.eq_id)">													
													<img class="img-fluid" width="70" v-lazy="'/static/images/equipment/icon_equipment_'+ item.eq_id +'.png'" :title="item.eq_name">
												</div>
											</div>
										</div>
									</div>
								</transition>
								<transition name="expand" @enter="enter" @after-enter="afterEnter" @leave="leave">
									<div class="col-12 mt-2" v-if="ignoreEqRank">
										<div class="d-flex flex-nowrap armory-function sticky-top p-1">
											<button class="pcbtn mr-3" @click="changeFilterEqRank(100000)" :class="this.filterEqRank >= 100000 ? 'active' : ''">
												{{ $t("none") }}
											</button>
											<!-- <button class="pcbtn mr-3" @click="changeFilterEqRank(101000)" :class="this.filterEqRank >= 101000 ? 'active' : ''">
												{{$t('blue')}}
											</button>
											<button class="pcbtn mr-3" @click="changeFilterEqRank(102000)" :class="this.filterEqRank >= 103000 ? 'active' : ''">
												{{$t('brown')}}
											</button> -->
											<button class="pcbtn mr-3" @click="changeFilterEqRank(104000)" :class="this.filterEqRank >= 104000 ? 'active' : ''">
												{{ $t("silver") }}
											</button>
											<button class="pcbtn mr-3" @click="changeFilterEqRank(105000)" :class="this.filterEqRank >= 105000 ? 'active' : ''">
												{{ $t("gold") }}
											</button>
											<button class="pcbtn mr-3" @click="changeFilterEqRank(106000)" :class="this.filterEqRank >= 106000 ? 'active' : ''">
												{{ $t("purple") }}
											</button>
											<button class="pcbtn mr-3" @click="changeFilterEqRank(107000)" :class="this.filterEqRank >= 107000 ? 'active' : ''">
												{{ $t("red") }}
											</button>
											<button class="pcbtn mr-3" @click="changeFilterEqRank(108000)" :class="this.filterEqRank >= 108000 ? 'active' : ''">
												{{ $t("green") }}
											</button>
											<button class="pcbtn mr-3" @click="changeFilterEqRank(109000)" :class="this.filterEqRank >= 109000 ? 'active' : ''">
												{{ $t("orange") }}
											</button>
											<button class="pcbtn mr-3" @click="changeFilterEqRank(10000000)" :class="this.filterEqRank >= 10000000 ? 'active' : ''">
												{{ $t("pink") }}
											</button>
										</div>
									</div>
								</transition>
							</div>
						</h3>
					</div>
				</div>
				<div class="col-lg-12 col-md-12 col-12 mb-3" v-if="teamList.length > 0">
					<template v-if="displayMode == 1">
						<h3 class="item-title">{{ $t("EquipmentMode") }}</h3>
						<!-- <div class="row mb-3">
							<div class="col-12 col-lg-6">
								<div class="form-group row">
									<label class="col-sm-2 col-form-label col-form-label-sm">
										專武上限
									</label>
									<div class="col-sm-10">
										<select class="form-control form-control-sm" v-model="uqTop">
											<option value="110">110</option>
											<option value="130">130</option>
											<option value="140">140</option>
											<option value="150">150</option>
											<option value="160">160</option>
											<option value="170">170</option>
											<option value="180">180</option>
											<option value="190">190</option>
											<option value="200">200</option>
											<option value="210">210</option>
										</select>
									</div>
								</div>
							</div>
						</div> -->
						<div class="p-1 armory-box armory-equipment-box" v-if="!eqDetail">
							<div class="d-flex flex-wrap justify-content-lg-start justify-content-center">
								<div class="card m-1" v-for="item in myEqList" :key="item.eq_id">
									<router-link :to="{ name: 'EquipmentDetail', params: { id: item.eq_name } }" target="_blank">
										<img class="img-fluid" v-lazy="'/static/images/equipment/icon_equipment_' + item.eq_id + '.png'" :title="item.eq_name" />
									</router-link>
									<div class="card-footer text-center">
										{{ item.count }}
									</div>
								</div>
							</div>
						</div>
						<div class="p-1 armory-box equipment-detail eq-mode-detail" v-else>
							<div class="card-deck justify-content-lg-start justify-content-center">
								<div class="card m-1" v-for="item in myEqList" :key="item.eq_id">
									<router-link :to="{ name: 'EquipmentDetail', params: { id: item.eq_name } }" target="_blank">
										<img class="card-img-top img-fluid" v-lazy="'/static/images/equipment/icon_equipment_' + item.eq_id + '.png'" />
									</router-link>
									<h6 class="m-1 mb-2">{{ getI18nName(item, "eq_name") }}</h6>
									<div class="d-flex flex-wrap">
										<div v-for="unit in item.unit" class="unit">
											<div v-if="unit.toString().includes('eq')">
												<img style="width: 30px" v-lazy="'/static/images/equipment/icon_equipment_' + unit.toString().replace('eq', '') + '.png'" />
											</div>
											<img v-else style="width: 30px" v-lazy="'/static/images/unit/icon_unit_' + (Number(unit) + 30) + '.png'" alt="" />
										</div>
									</div>
									<div class="card-footer text-center mt-auto">
										{{ item.count }}
									</div>
								</div>
							</div>
						</div>
					</template>
					<template v-if="displayMode == 2">
						<h3 class="item-title">{{ $t("RecipeMode") }}</h3>
						<div class="d-flex flex-nowrap justify-content-lg-end justify-content-start mb-3">
							<button type="button" class="pcbtn mr-3" :class="{ active: fastChangeStock }" @click="showFastStock()">
								{{ $t("FastEdit") }}
							</button>
							<button type="button" data-toggle="modal" data-target="#FastChangeCaption" class="pcbtn mr-3">
								{{ $t("FastEditCaption") }}
							</button>
						</div>
						<div class="item-content p-1 armory-box equipment-detail recipe-mode">
							<div class="card-deck justify-content-sm-center justify-content-lg-start">
								<div class="card m-1" v-for="item in recipeList" v-if="hiddenOverflow && countRecipe(item) > 0">
									<router-link :to="{ name: 'EquipmentDetail', params: { id: item.eq_name } }" target="_blank">
										<img class="card-img-top img-fluid" width="80" v-lazy="'/static/images/equipment/icon_equipment_' + item.eq_craft + '.png'" />
									</router-link>
									<h6 style="min-height: 40px" class="m-1">{{ getI18nName(item, "eq_name") }}</h6>
									<div class="text-left px-3 mb-3 recipe-count">
										<div v-html="countRecipeHtml(item)"></div>
									</div>
									<div v-if="fastChangeStock">
										<input type="number" class="form-control recipe-input" :value="nowStock(item.eq_craft)" v-on:keyup.enter="changeStock($event.target.value, item.eq_craft)" v-on:blur="changeStock($event.target.value, item.eq_craft)" />
									</div>
								</div>
								<div class="card m-1" v-else-if="!hiddenOverflow">
									<router-link :to="{ name: 'EquipmentDetail', params: { id: item.eq_name } }" target="_blank">
										<img class="card-img-top img-fluid" width="80" v-lazy="'/static/images/equipment/icon_equipment_' + item.eq_craft + '.png'" />
									</router-link>
									<h6 class="m-1">{{ getI18nName(item, "eq_name") }}</h6>
									<div class="text-left px-3 mb-3 recipe-count">
										<div v-html="countRecipeHtml(item)"></div>
									</div>
									<div v-if="fastChangeStock">
										<input type="number" class="form-control recipe-input" onclick="this.select()" :value="nowStock(item.eq_craft)" v-on:keyup.enter="changeStock($event.target.value, item.eq_craft)" v-on:blur="changeStock($event.target.value, item.eq_craft)" />
									</div>
								</div>
							</div>
						</div>
					</template>
					<template v-if="(displayMode == 3 && stopCalculate) || (displayMode == 9 && stopCalculate)">
						<div>
							<table class="table table-bordered mapDrop-table">
								<thead>
									<tr>
										<th colspan="3">
											{{ $t("Pausing") }}
										</th>
									</tr>
								</thead>
							</table>
						</div>
					</template>
					<template v-if="(displayMode == 3 && !stopCalculate) || (displayMode == 9 && !stopCalculate)">
						<h3 v-if="displayMode == 3" class="item-title">{{ $t("MapDropMode") }}</h3>
						<h3 v-if="displayMode == 9" class="item-title">
							{{ $t("FocusMode") }} <small> -- {{ $t("FocusModeCaption") }}</small>
						</h3>
						<div class="row mb-3">
							<div class="col-12 col-lg-6">
								<div class="form-group row">
									<label class="col-sm-2 col-form-label col-form-label-sm">
										{{ $t("FilterMap") }}
									</label>
									<div class="col-sm-10">
										<select class="form-control form-control-sm" v-model="filterMap">
											<option value="">{{ $t("none") }}</option>
											<option value="70">70</option>
											<option value="69">69</option>
											<option value="68">68</option>
											<option value="68.5">68.5</option>
											<option value="67">67</option>
											<option value="67.5">67.5</option>
											<option value="66">66</option>
											<option value="66.5">66.5</option>
											<option value="65">65</option>
											<option value="65.5">65.5</option>
											<option value="64">64</option>
											<option value="64.5">64.5</option>
											<option value="63">63</option>
											<option value="63.5">63.5</option>
											<option value="62">62</option>
											<option value="62.7">62 {{ $t("Upper") }}</option>
											<option value="61">61</option>
											<option value="61.7">61 {{ $t("Upper") }}</option>
											<option value="60">60</option>
											<option value="60.7">60 {{ $t("Upper") }}</option>
											<option value="59">59</option>
											<option value="59.7">59 {{ $t("Upper") }}</option>
											<option value="58">58</option>
											<option value="58.7">58 {{ $t("Upper") }}</option>
											<option v-for="n in reverseKeys(57)" :value="n + 1">
												{{ n + 1 }}
											</option>
										</select>
									</div>
								</div>
							</div>
							<div class="col-12 col-lg-6">
								<div class="form-group row">
									<label class="col-sm-2 col-form-label col-form-label-sm">
										{{ $t("MapTop") }}
									</label>
									<div class="col-sm-10">
										<select class="form-control form-control-sm" v-model="filterMapTop" v-on:change="saveMapTop">
											<option value="">{{ $t("none") }}</option>
											<option value="70">70</option>
											<option value="69">69</option>
											<option value="68">68</option>
											<option value="68.5">68.5</option>
											<option value="67">67</option>
											<option value="67.5">67.5</option>
											<option value="66">66</option>
											<option value="66.5">66.5</option>
											<option value="65">65</option>
											<option value="65.5">65.5</option>
											<option value="64">64</option>
											<option value="64.5">64.5</option>
											<option value="63">63</option>
											<option value="63.5">63.5</option>
											<option value="62">62</option>
											<option value="62.7">62 {{ $t("Upper") }}</option>
											<option value="61">61</option>
											<option value="61.7">61 {{ $t("Upper") }}</option>
											<option value="60">60</option>
											<option value="60.7">60 {{ $t("Upper") }}</option>
											<option value="59">59</option>
											<option value="59.7">59 {{ $t("Upper") }}</option>
											<option value="58">58</option>
											<option value="58.7">58 {{ $t("Upper") }}</option>
											<option v-for="n in reverseKeys(57)" :value="n + 1">
												{{ n + 1 }}
											</option>
										</select>
									</div>
								</div>
							</div>
							<div class="col-12 col-lg-6">
								<div class="form-group row">
									<label class="col-sm-2 col-form-label col-form-label-sm">
										{{ $t("PerPage") }}
									</label>
									<div class="col-sm-10">
										<select class="form-control form-control-sm" v-model="pageSize">
											<option value="10">10</option>
											<option value="20">20</option>
											<option value="50">50</option>
											<option value="100">100</option>
											<option value="1000">全部</option>
										</select>
									</div>
								</div>
							</div>
							<div class="col-12 col-lg-6">
								<div class="form-group row">
									<label class="col-sm-2 col-form-label col-form-label-sm">
										{{ $t("SearchGear") }}
									</label>
									<div class="col-sm-10">
										<input type="text" class="form-control form-control-sm" v-on:input="debounceInputFilterEq" :placeholder="$t('EquipmentName')" :value="filterEq" />
									</div>
								</div>
							</div>
						</div>
						<table class="table table-bordered mapDrop-table">
							<thead>
								<tr>
									<th colspan="3">
										{{ $t("TotalStamina") }}: {{ Math.ceil(totalCost / dropRate) }} / {{ Math.ceil(totalCost / dropRate / 120) }}
										{{ $t("Refill") }}
									</th>
								</tr>
								<tr>
									<th style="min-width: 67px; vertical-align: baseline;">{{ $t("Area") }}</th>
									<th style="min-width: 67px; vertical-align: baseline;">{{ $t("Need") }}</th>
									<th>
										<div class="d-block w-100 text-center mb-3">{{ $t("DropList") }}</div>
										<div class="text-center">
											<button type="button" @click="filterEq = ''" :class="{ active: filterEq }" class="pcbtn mr-3 mb-3">
												{{ $t("ClearFilterEq") }}
											</button>
											<button type="button" data-toggle="modal" data-target="#FastChangeCaption" class="pcbtn mr-3 mb-3">
												{{ $t("FastEditCaption") }}
											</button>
											<button type="button" title="計算當前地圖" class="pcbtn btn mr-3 mb-3" :class="{ active: mapEdit }" @click="mapEditBtn()">
												{{ $t("EditByMap") }}
											</button>
											<button type="button" title="輸入刷到的數量會直接加上庫存" v-if="fastChangeStock" class="pcbtn mr-3 mb-3" :class="{ active: fastPluseStock }" @click="showFastPluseStock()">
												{{ $t("plus_item") }}
											</button>
											<button type="button" class="pcbtn mr-3 mb-3" :class="{ active: fastChangeStock }" @click="showFastStock()">
												{{ $t("FastEdit") }}
											</button>
											<button type="button" class="pcbtn mr-3 mb-3" :class="{ active: showSubDrop }" @click="showSubDropBtn()">
												{{ $t("ExtraDrop") }}
											</button>
											<select class="custom-select mr-3 mb-3 d-inline form-control form-control-sm" style="width: 110px;" v-model="dropRate">
												<option selected="selected" value="1">{{ $t("DropRate") }}</option>
												<option value="1">1 {{ $t("Multiple") }}</option>
												<option value="2">2 {{ $t("Multiple") }}</option>
												<option value="3">3 {{ $t("Multiple") }}</option>
												<option value="4">4 {{ $t("Multiple") }}</option>
											</select>
										</div>
									</th>
								</tr>
							</thead>
							<tbody>
								<template v-for="quest in mapDropList">
									<tr v-bind:key="quest.quest_name">
										<td rowspan="2">{{ quest.quest_name }}</td>
										<td>
											{{ quest.totalMapDrop }}
										</td>
										<td align="center">
											<div class="d-flex flex-wrap justify-content-center">
												<div v-for="(item, index) in quest.quest_drop_item_list" class="p-2 text-center mapDrop-item mr-2">
													<!-- <router-link :to="{ name: 'EquipmentDetail', params: { id: item.reward_name }}" target='_blank'>
														<img width="70" :title="item.reward_name" class="aligncenter" v-lazy="'/static/images/equipment/icon_equipment_'+ item.reward_id +'.png'" :style="item.mapCount == '0' ? 'opacity: 0.5': ''">
													</router-link> -->
													<img width="70" :title="item.reward_name" class="aligncenter cursor-pointer" v-lazy="'/static/images/equipment/icon_equipment_' + item.reward_id + '.png'" :style="item.mapCount == '0' ? 'opacity: 0.5' : ''" @click="setFilterEqSubDropName(item.reward_name, '')" />
													<!-- <div class="d-block mt-1">
														<div class="d-inline-block">
															<i class="icon-custom glass pointer-curse"></i>
														</div>
														<div class="d-inline-block">
															<i class="icon-custom goOut pointer-curse"></i>
														</div>
													</div> -->
													<h6 class="dropOdd text-center">{{ item.odds }}<span style="font-size: 12px">%</span></h6>
													<span class="oddTri"></span>
													<span class="text-center py-1 d-block">
														{{ item.mapCount ? item.mapCount : item.overflow }}
													</span>
													<span v-if="fastChangeStock" class="">
														<input type="number" class="form-control mb-1 inputStock" onclick="this.select()" :value="nowStock(item.reward_id)" v-on:keyup.enter="changeStock($event.target.value, item.reward_id)" v-on:blur="changeStock($event.target.value, item.reward_id)" />
													</span>
													<span v-if="fastPluseStock && fastChangeStock">
														<input style="border-color: #d0749b" type="number" class="form-control inputPluse" onclick="this.select()" v-on:keyup.enter="pluseStock($event, $event.target.value, item.reward_id)" v-on:blur="pluseStock($event, $event.target.value, item.reward_id)" />
													</span>
												</div>
											</div>
											<div class="d-flex flex-wrap justify-content-center my-1" v-if="showSubDrop">
												<div v-for="(item, index) in quest.subDropItemList" class="p-2 text-center mapDrop-item m-2">
													<img width="70" class="aligncenter cursor-pointer" v-lazy="'/static/images/equipment/icon_equipment_' + item.eq_id + '.png'" :style="item.mapCount == '0' ? 'opacity: 0.5' : ''" @click="setFilterEqSubDropName('', item.eq_id)" />
													<h6 class="dropOdd text-center">{{ item.odds }}<span style="font-size: 12px">%</span></h6>
													<span class="oddTri"></span>
													<span class="text-center py-1 d-block">
														{{ item.mapCount ? item.mapCount : item.overflow }}
													</span>
													<span v-if="fastChangeStock" class="">
														<input type="number" class="form-control mb-1 inputStock" onclick="this.select()" :value="nowStock(item.eq_craft)" v-on:keyup.enter="changeStock($event.target.value, item.eq_craft)" v-on:blur="changeStock($event.target.value, item.eq_craft)" />
													</span>
													<span v-if="fastPluseStock && fastChangeStock">
														<input style="border-color: #d0749b" type="number" class="form-control inputPluse" onclick="this.select()" v-on:keyup.enter="pluseStock($event, $event.target.value, item.eq_craft)" v-on:blur="pluseStock($event, $event.target.value, item.eq_craft)" />
													</span>
												</div>
											</div>
											<div class="d-flex flex-nowrap justify-content-center mt-3" v-if="mapEdit">
												<button type="button" class="pcbtn" @click="questEdit(quest)">{{ quest.quest_name }}</button>
											</div>
										</td>
									</tr>
									<td colspan="2" align="center">
										{{ $t("Total") }}: <span class="">{{ Math.ceil(quest.times / dropRate) }}</span> {{ $t("Attempts") }}
										<!-- ，建議: <span class="">{{Math.ceil((quest.times * 0.7) / dropRate)}}</span> 次  -->, {{ $t("Stamina") }}:
										<span class="">{{ Math.ceil((quest.times * quest.stamina) / dropRate) }}</span> /
										<span class="">{{ Math.ceil((quest.times * quest.stamina) / dropRate / 120) }} {{ $t("Refill") }}</span>
									</td>
								</template>
								<tr>
									<td colspan="3">
										<paginate :pageCount="pageCount" :page-range="10" :prevText="'Prev'" :nextText="'Next'" :containerClass="'pagination justify-content-center'" :page-class="'page-item'" :page-link-class="'page-link'" :container-class="'pagination'" :prev-class="'page-item'" :prev-link-class="'page-link'" :next-class="'page-item'" :next-link-class="'page-link'" :click-handler="pageCallback">
										</paginate>
									</td>
								</tr>
							</tbody>
						</table>
					</template>
					<template v-if="displayMode == 7">
						<h3 class="item-title">{{ $t("HVhMode") }} {{ $t("BetaTest") }}<small>目前只做裝備需求排序</small></h3>
						<table width="1000px" class="table table-bordered mapDrop-table">
							<thead>
								<tr>
									<th style="min-width: 67px; vertical-align: baseline;">{{ $t("Area") }}</th>
									<th style="min-width: 67px; vertical-align: baseline;">{{ $t("Require") }}</th>
									<th>
										{{ $t("DropList") }}
									</th>
								</tr>
							</thead>
							<tbody>
								<template v-for="quest in hardDropList">
									<tr v-bind:key="quest.quest_name">
										<td v-html="quest.quest_name"></td>
										<td>
											{{ quest.totalMapDrop }}
										</td>
										<td align="center">
											<div class="d-flex flex-nowrap justify-content-center">
												<div v-for="(item, index) in quest.quest_drop_item_list" class="p-2 text-center mapDrop-item mr-2" :key="item.reward_id" v-if="item.reward_type != '2'">
													<router-link :to="{ name: 'EquipmentDetail', params: { id: item.reward_name } }" target="_blank">
														<img width="65" :title="item.reward_name" class="aligncenter" v-lazy="'/static/images/equipment/icon_equipment_' + item.reward_id + '.png'" :style="item.mapCount == '0' ? 'opacity: 0.5' : ''" />
													</router-link>
													<h6 class="dropOdd text-center">{{ item.odds }}<span style="font-size: 12px">%</span></h6>
													<span class="oddTri"></span>
													<span class="text-center py-1 d-block">
														{{ item.mapCount ? item.mapCount : item.overflow }}
													</span>
												</div>
												<div v-else class="p-2 text-center mapDrop-item mr-2">
													<img width="65" class="aligncenter" v-lazy="'/static/images/item/icon_item_' + item.reward_id + '.png'" />
												</div>
											</div>
										</td>
									</tr>
								</template>
								<tr>
									<td colspan="3">
										<paginate :pageCount="pageCount" :page-range="10" :prevText="'Prev'" :nextText="'Next'" :containerClass="'pagination justify-content-center'" :page-class="'page-item'" :page-link-class="'page-link'" :container-class="'pagination'" :prev-class="'page-item'" :prev-link-class="'page-link'" :next-class="'page-item'" :next-link-class="'page-link'" :click-handler="pageCallback">
										</paginate>
									</td>
								</tr>
							</tbody>
						</table>
					</template>
					<template v-if="displayMode == 5">
						<h3 class="item-title">{{ $t("ItemBox") }}</h3>
						<div class="d-flex flex-nowrap justify-content-lg-end justify-content-start">
							<button type="button" class="pcbtn mb-3" :class="{ active: editItemOrder }" @click="showItemOrder()">
								{{ $t("Edit") }}
							</button>
						</div>
						<div class="d-flex flex-wrap">
							<div class="itemBox col p-2" v-for="item in myItemList" :key="item.equipment_id">
								<template v-if="editItemOrder">
									<div class="little-mark" @click="itemDisable(item)" v-if="item.active == 1">
										<span class="icon-custom minus"></span>
									</div>
									<div class="little-mark" @click="itemDisable(item)" v-else>
										<span class="icon-custom"></span>
									</div>
								</template>
								<img style="width: 80px" v-lazy="'/static/images/equipment/icon_equipment_' + item.equipment_id + '.png'" :alt="getEqName(item.equipment_id)" :title="getEqName(item.equipment_id)" />
								<input class="form-control" style="width: 80px" type="number" value="0" v-model.number="item.count" onclick="this.select()" />
							</div>
						</div>
					</template>
					<template v-if="displayMode == 8">
						<h3 class="item-title">
							{{ $t("ResourcesMode") }} <br /><img class="my-1" style="width: 30px" src="/static/images/item/icon_item_31000.png" title="ex" />
							x 3000 Total: {{ totalMp }} Lack: {{ totalLack }}
						</h3>
						<div class="d-flex flex-wrap mb-3 justify-content-lg-start justify-content-center">
							<div class="p-2 armory-box mr-3 mb-3 resources-item" v-for="item in myMpList" style="max-width: 24%;">
								<div class="row">
									<div class="col-12">
										<div class="d-block text-center mb-2">
											{{ getCharaName(item.unit_id) }}
										</div>
										<div class="d-flex align-items-start">
											<div class="d-inline">
												<div class="armory-img-box edit-box gacha-item" :class="checkPromo(item.promotion_level, item.trace)">
													<img v-if="!item.rarity" v-lazy="'/static/images/unit/icon_unit_' + (Number(item.unit_id) + 30) + '.png'" alt="" />
													<img v-lazy="'/static/images/unit/icon_unit_' + (Number(item.unit_id) + 10) + '.png'" alt="" v-else-if="item.rarity < 3" />
													<img v-else-if="item.rarity <= 5 && item.rarity >= 3" v-lazy="'/static/images/unit/icon_unit_' + (Number(item.unit_id) + 30) + '.png'" alt="" />
													<img v-else v-lazy="'/static/images/unit/icon_unit_' + (Number(item.unit_id) + 60) + '.png'" alt="" />
													<div class="star-box" v-if="item.rarity != '6' && item.rarity">
														<span v-for="n in 5" class="rarity">
															<img src="/static/images/star.png" v-if="n <= Number(item.rarity)" />
															<img src="/static/images/star_dark.png" v-else />
														</span>
													</div>
													<div class="star-box" v-else-if="item.rarity == '6' && item.rarity">
														<span class="rarity pink">
															<img src="/static/images/star_pink.png" width="15px" />
														</span>
													</div>
													<div class="uq-mark" v-if="item.uqEq > 0">
														<img src="/static/images/uneq.png" />
													</div>
												</div>
												<input class="form-control d-inline" style="width: 90px" type="number" value="0" v-model.number.lazy="item.count" onclick="this.select()" />
											</div>
											<!-- <div class="d-inline" style="width: 80px">
												<img class="my-1" v-lazy="'/static/images/unit/icon_unit_'+ (Number(item.unit_id) +30) +'.png'" alt="">
												<br />
												<input class="form-control d-inline" style="width: 80px" type="number" value="0" v-model.number.lazy="item.count" onclick="this.select()">
											</div> -->
											<div class="align-self-start mx-3">
												<span class="d-block">
													{{ $t("UEshort") }}: <span v-if="item.uqEq">{{ item.uqEq }}</span>
													<span v-else>{{ $t("none") }}</span>
												</span>
												<span class="d-block" v-if="item.memo > 0">
													<img class="my-1" style="width: 30px" v-lazy="'/static/images/item/icon_item_3' + item.unit_id.slice(0, -2) + '.png'" title="" />
													x {{ item.memo }}
												</span>
												<span class="d-block" v-if="item.heart > 0">
													<img class="my-1" style="width: 30px" src="/static/images/equipment/icon_equipment_140001.png" title="公主之心（碎片）" />
													x {{ item.heart }}
												</span>
												<span class="d-block" v-if="item.lbMemo > 0">
													<img class="my-1" style="width: 30px" v-lazy="'/static/images/item/icon_item_3' + item.unit_id.slice(0, -2) + '.png'" title="" />
													x {{ item.lbMemo }}
												</span>
												<span class="d-block" v-if="item.total">
													{{ item.count - item.total }}
												</span>
												<br />
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</template>
					<template v-if="displayMode == 6">
						<h3 class="item-title">{{ $t("Setting") }}</h3>
						<ul class="setting-box">
							<li class="list-group-item">
								<div class="row">
									<div class="col-lg-10 col-12">
										<h3 class="item-sub-title">介面語系 Language</h3>
										<p>
											測試版，只修改了部分介面的語系。<br />
											This only change part of user interface language, not data itself. Beta ver.
										</p>
									</div>
									<div class="col-lg-2 col-12">
										<ul class="list-group list-group-flush">
											<select class="custom-select form-control-sm" v-model="locale">
												<option value="tw">繁體中文</option>
												<option value="cn">简体中文</option>
												<option value="en">English (US)</option>
												<option value="jp">日本語</option>
											</select>
										</ul>
									</div>
								</div>
							</li>
							<li class="list-group-item">
								<div class="row">
									<div class="col-lg-8 col-12">
										<h3 class="item-sub-title">{{ $t("AutoReduce") }}</h3>
										<p>
											在編輯角色畫面中穿上裝備時，自動減少道具欄該裝備所需之設計圖數量。<br />
											目前只支援當前RANK穿上後自動減少庫存。 <br />
											Used to consume equipment shards from inventory if you equip a new piece. only support same rank.
										</p>
									</div>
									<div class="col-lg-4 col-12">
										<label class="switch">
											<input type="checkbox" class="primary d-none" @click="changeAutoSubtraction()" v-model="autoSubtraction" />
											<span class="slider round"></span>
										</label>
									</div>
								</div>
							</li>
							<li class="list-group-item">
								<div class="row">
									<div class="col-lg-8 col-12">
										<h3 class="item-sub-title">{{ $t("FastShow") }}</h3>
										<p>
											{{ $t("fast_show_caption") }}
										</p>
									</div>
									<div class="col-lg-4 col-12">
										<label class="switch">
											<input type="checkbox" class="primary d-none" @click="showUnitEq()" v-model="fastSee" />
											<span class="slider round"></span>
										</label>
									</div>
								</div>
							</li>
							<li class="list-group-item">
								<div class="row">
									<div class="col-lg-8 col-12">
										<h3 class="item-sub-title">計算銀裝</h3>
										<p>
											在裝備/設計圖/地圖模式內，計算銀色框的裝備。
										</p>
									</div>
									<div class="col-lg-4 col-12">
										<label class="switch">
											<input type="checkbox" class="primary d-none" @click="changeShowRank()" v-model="ignoreEqRank" />
											<span class="slider round"></span>
										</label>
									</div>
								</div>
							</li>
							<li class="list-group-item">
								<div class="row">
									<div class="col-lg-8 col-12">
										<h3 class="item-sub-title">{{ $t("EquipmentMode") }} - {{ $t("detail_list") }}</h3>
										<p>
											在裝備模式內，顯示顯示缺此裝的角色。 Show whe need this equipment in equipment mode.
										</p>
									</div>
									<div class="col-lg-4 col-12">
										<label class="switch">
											<input type="checkbox" class="primary d-none" @click="showDetail()" v-model="eqDetail" />
											<span class="slider round"></span>
										</label>
									</div>
								</div>
							</li>
							<li class="list-group-item">
								<div class="row">
									<div class="col-lg-8 col-12">
										<h3 class="item-sub-title">{{ $t("RecipeMode") }} - {{ $t("HideOverFlow") }}</h3>
										<p>
											不顯示裝備庫中，庫存超出需求的裝備。 Recipe mode hide item you dont need.
										</p>
									</div>
									<div class="col-lg-4 col-12">
										<label class="switch">
											<input type="checkbox" class="primary d-none" @click="showOverflow()" v-model="hiddenOverflow" />
											<span class="slider round"></span>
										</label>
									</div>
								</div>
							</li>
							<li class="list-group-item">
								<div class="row">
									<div class="col-lg-8 col-12">
										<h3 class="item-sub-title">{{ $t("RecipeMode") }}/{{ $t("MapDropMode") }} - {{ $t("4year_reduction") }}</h3>
										<p>
											2019~2022日版四周年裝備製作的設計圖需求量減少，將設計圖的數量變更為四周年前的需求數量。<br />
											Gear cost reduction from nnk pool to 4 year anniversary.<br />
											English/Global server player should switch on until the 4th anniversary.
										</p>
									</div>
									<div class="col-lg-4 col-12">
										<label class="switch">
											<input type="checkbox" class="primary d-none" @click="isOldVersion()" v-model="oldVersion" />
											<span class="slider round"></span>
										</label>
									</div>
								</div>
							</li>
							<!-- <li class="list-group-item">
								<div class="row">
									<div class="col-lg-8 col-12">
										<h3 class="item-sub-title">設計圖/地圖模式 - {{$t('OldVersion2019')}}</h3>
										<p>
											將設計圖的數量變更為2019前的舊版需求數量。
											Gear cost reduction before nnk pool
										</p>
									</div>
									<div class="col-lg-4 col-12">
										<label class="switch">
											<input type="checkbox" class="primary d-none" @click="isOldVersion2019()" v-model="oldVersion2019">
											<span class="slider round"></span>
										</label>
									</div>
								</div>
							</li> -->
							<li class="list-group-item">
								<div class="row">
									<div class="col-lg-8 col-12">
										<h3 class="item-sub-title">{{ $t("RecipeMode") }}/{{ $t("MapDropMode") }} - {{ $t("FastEdit") }}</h3>
										<p>
											該模式下顯示可修改道具欄的輸入框。<br />
											輸入完成後<span class="font-red error">按下 Enter↵ 鍵或離開輸入框</span>觸發修改 <br />
											Fast edit current item. Trigger by enter or blur input box.
										</p>
									</div>
									<div class="col-lg-4 col-12">
										<label class="switch">
											<input type="checkbox" class="primary d-none" @click="showFastStock()" v-model="fastChangeStock" />
											<span class="slider round"></span>
										</label>
									</div>
								</div>
							</li>
							<li class="list-group-item">
								<div class="row">
									<div class="col-lg-8 col-12">
										<h3 class="item-sub-title">{{ $t("MapDropMode") }} - {{ $t("plus_item") }}</h3>
										<p>
											該模式下顯示可修改道具欄的輸入框。<br />
											輸入打到的數字即可加入至庫存。<br />
											輸入完成後<span class="font-red error">按下 Enter↵ 鍵或離開輸入框</span>觸發修改 <br />
											Fast item addition. current item from your inventory + loot item . Trigger by enter or blur input box.
										</p>
									</div>
									<div class="col-lg-4 col-12">
										<label class="switch">
											<input type="checkbox" class="primary d-none" @click="showFastPluseStock()" v-model="fastPluseStock" />
											<span class="slider round"></span>
										</label>
									</div>
								</div>
							</li>
							<li class="list-group-item">
								<div class="row">
									<div class="col-lg-8 col-12">
										<h3 class="item-sub-title">{{ $t("MapDropMode") }} - {{ $t("dropRateUpdate") }}</h3>
										<p>
											2022/10/15 主線任務掉落機率提升 36% -> 54% , 24% -> 36%
											<br />
											2022/10/15 main quest drop rate update 36% -> 54% , 24% -> 36%
											<br />
											<a target="_blank" href="https://priconne-redive.jp/news/update/19627/">「メインクエスト」ノーマルクエスト　ドロップ率引き上げ決定！</a>
										</p>
									</div>
									<div class="col-lg-4 col-12">
										<label class="switch">
											<input type="checkbox" class="primary d-none" @click="updateDropRate()" v-model="dropRateUpdate" />
											<span class="slider round"></span>
										</label>
									</div>
								</div>
							</li>
						</ul>
					</template>
				</div>
				<div v-if="isLoading">
					<div @click="isLoading = false" style="cursor: pointer;position: fixed;top: 0;right:10px;z-index: 11111;color: white;font-size: 50px;text-shadow: 0px 0px 5px black;">
						<span>×</span>
					</div>
					<Loading />
				</div>
			</div>
			<div id="scroll-fixed-bottom" class="armory-function scroll-fixed-bottom">
				<button v-if="teamList.length > 0" class="pcbtn primary" @click="saveTeam">儲存<br />隊伍</button>
			</div>
			<div class="row" style="min-height: 300px">
				<div class="col-lg-4 col-12">
					<b>簡易裝備統計表</b><br />
					使用說明<br />
					1.加入需要計算的角色。<br />
					2.裝備角色裝備後會自動計算缺的裝備。<br />
					3.使用道具欄，修改庫存計算裝備缺額。<br />
					4.儲存隊伍。<br />
					註: 儲存資訊只會記在當前瀏覽器。<br />
					註: 缺的越多計算越久。<br />
					註: 覺得慢的話不要在{{ $t("MapDropMode") }}編輯角色。<br />
					註: 若出現資訊不符，請刪除角色再加入一次。<br />
					註: 任何修改都須點選儲存隊伍，系統不會自動儲存。<br />
				</div>
				<div class="col-lg-4 col-12">
					<b>Armory</b><br />
					How to use.<br />
					1.Add units.<br />
					2.Modifying units.<br />
					4.Importing item box.<br />
					5.Then auto calculate what you need.<br />
					6.Click Save Box or export as text and save where you like.<br />
					p.s. "Save Box" button save data in current browser.<br />
					If you clear the browser history data will be lost.<br />
					Global server need active 'Pre-4th-anniversary set' button.<br />
					If you feel lag , dont edit unit in {{ $t("MapDropMode") }}<br />
					this is google translate.<br />
				</div>
				<div class="col-lg-4 col-12">
					If you play global server. There is English guide by Lino#8227 <br />
					Link :
					<a href="https://docs.google.com/document/d/1dGWA7XCfGSQzWxGxcBAHBxVvMm0RyGpIAs9lUi9i-MY/edit?usp=sharing" target="_blank">
						Armory Guide
					</a>
					<br />
					If there is a problem with this link. please notify me.
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import axios from "axios";
import Loading from "@/components/Loading.vue";
import Paginate from "vuejs-paginate";
import ReduceEq from "../assets/edata/equipment_craft_reduce.json";
import ReduceEq2019 from "../assets/edata/equipment_craft_reduce2019.json";
import pako from "pako";
import Solver from "javascript-lp-solver";
import ExtraDrop from "../assets/edata/extraDrop.json";
import UqLevel from "../assets/edata/uqLevel.json";
import GachaPool from "../assets/edata/gacha_pool.json";
import unit_talent from "../assets/edata/unit_talent.txt";
import html2canvas from "html2canvas";

export default {
	name: "Armory",
	components: {
		Loading,
		Paginate,
	},
	data() {
		return {
			star3: {},
			star2: {},
			star1: {},
			teamList: [],
			selectUnit: {},
			currentPage: 1,
			pageCount: 1,
			pageSize: 10,
			editing: false,
			currentSlot: "Slot1",
			tempSlotData: {
				id: "",
				name: "",
			},
			playerStatus: {
				name: "佑樹",
				level: "300",
				power: "1234567",
				howToPlay: "保500",
				server: "美食",
				intro: "每天上線\n公會戰打滿3刀\n輕鬆玩遊戲",
			},
			exportActive: false,
			filterEqActive: false,
			saveSlotActive: false,
			notSupport: false,
			isLoading: false,
			stopCalculate: false,
			eqDetail: false,
			displayMode: 1,
			orderDesc: true,
			eqCraft: true,
			mapEdit: false,
			editItemOrder: false,
			hiddenOverflow: true,
			autoSubtraction: true,
			lzw: "",
			importTxt: "",
			fastSee: false,
			showAddUnitName: false,
			fastChangeStock: false,
			fastPluseStock: false,
			filterEqList: [],
			filterUnitName: "",
			filterPosition: "rank",
			filterEq: "",
			filterMap: "",
			filterMapTop: "",
			exportNotice: "",
			slotSetting: [{
					id: "Slot1",
					name: "Slot 1",
					active: true,
				},
				{
					id: "Slot2",
					name: "Slot 2",
					active: false,
				},
				{
					id: "Slot3",
					name: "Slot 3",
					active: false,
				},
				{
					id: "Slot4",
					name: "Slot 4",
					active: false,
				},
				{
					id: "Slot5",
					name: "Slot 5",
					active: false,
				},
			],
			personalSetting: {
				customTrace: [{
						displayName: "自一",
						value: "21.3",
						displayOptionName: "自訂名稱一",
					},
					{
						displayName: "自二",
						value: "21.3",
						displayOptionName: "自訂名稱二",
					},
					{
						displayName: "自三",
						value: "21.3",
						displayOptionName: "自訂名稱三",
					},
					{
						displayName: "自四",
						value: "21.3",
						displayOptionName: "自訂名稱四",
					},
					{
						displayName: "自五",
						value: "21.3",
						displayOptionName: "自訂名稱五",
					},
				],
			},
			rankAll: {
				rList: [{ active: false }, { active: false }, { active: false }, { active: false }, { active: false }, { active: false }],
				promotion_level: 0,
				rarity: 0,
				trace: 0,
				putEquipment: 0,
				uqEq: 0,
			},
			rankTarget: {
				targetRank: 30,
				targetTrace: 30.5,
				rList: [{ active: false }, { active: false }, { active: false }, { active: false }, { active: false }, { active: false }],
				promotion_level: 0,
				rarity: 0,
				trace: 0,
				putEquipment: 0,
				uqEq: 0,
			},
			traceOption: [
				{ value: "34.0", displayName: "Rank 34(空)" },
				{ value: "34", displayName: "Rank 34(滿)" },
				{ value: "34.5", displayName: "Rank 34.5" },
				{ value: "34.4", displayName: "Rank 34.4" },
				{ value: "34.3", displayName: "Rank 34.3" },
				{ value: "33.0", displayName: "Rank 33(空)" },
				{ value: "33", displayName: "Rank 33(滿)" },
				{ value: "33.5", displayName: "Rank 33.5" },
				{ value: "33.4", displayName: "Rank 33.4" },
				{ value: "33.3", displayName: "Rank 33.3" },
				{ value: "32.0", displayName: "Rank 32(空)" },
				{ value: "32", displayName: "Rank 32(滿)" },
				{ value: "32.5", displayName: "Rank 32.5" },
				{ value: "32.4", displayName: "Rank 32.4" },
				{ value: "32.3", displayName: "Rank 32.3" },
				{ value: "31.0", displayName: "Rank 31(空)" },
				{ value: "31", displayName: "Rank 31(滿)" },
				{ value: "31.5", displayName: "Rank 31.5" },
				{ value: "31.4", displayName: "Rank 31.4" },
				{ value: "31.3", displayName: "Rank 31.3" },
				{ value: "30.0", displayName: "Rank 30(空)" },
				{ value: "30", displayName: "Rank 30(滿)" },
				{ value: "30.5", displayName: "Rank 30.5" },
				{ value: "30.4", displayName: "Rank 30.4" },
				{ value: "30.3", displayName: "Rank 30.3" },
				{ value: "29.0", displayName: "Rank 29(空)" },
				{ value: "29", displayName: "Rank 29(滿)" },
				{ value: "29.5", displayName: "Rank 29.5" },
				{ value: "29.4", displayName: "Rank 29.4" },
				{ value: "29.3", displayName: "Rank 29.3" },
				{ value: "28.0", displayName: "Rank 28(空)" },
				{ value: "28", displayName: "Rank 28(滿)" },
				{ value: "28.5", displayName: "Rank 28.5" },
				{ value: "28.4", displayName: "Rank 28.4" },
				{ value: "28.3", displayName: "Rank 28.3" },
				{ value: "27.0", displayName: "Rank 27(空)" },
				{ value: "27", displayName: "Rank 27(滿)" },
				{ value: "27.5", displayName: "Rank 27.5" },
				{ value: "27.4", displayName: "Rank 27.4" },
				{ value: "27.3", displayName: "Rank 27.3" },
				{ value: "26.0", displayName: "Rank 26(空)" },
				{ value: "26", displayName: "Rank 26(滿)" },
				{ value: "26.5", displayName: "Rank 26.5" },
				{ value: "26.4", displayName: "Rank 26.4" },
				{ value: "26.3", displayName: "Rank 26.3" },
				{ value: "25.0", displayName: "Rank 25(空)" },
				{ value: "25", displayName: "Rank 25(滿)" },
				{ value: "25.5", displayName: "Rank 25.5" },
				{ value: "25.4", displayName: "Rank 25.4" },
				{ value: "25.3", displayName: "Rank 25.3" },
				{ value: "24.0", displayName: "Rank 24(空)" },
				{ value: "24", displayName: "Rank 24(滿)" },
				{ value: "24.5", displayName: "Rank 24.5" },
				{ value: "24.4", displayName: "Rank 24.4" },
				{ value: "24.3", displayName: "Rank 24.3" },
				{ value: "23.0", displayName: "Rank 23(空)" },
				{ value: "23", displayName: "Rank 23(滿)" },
				{ value: "23.5", displayName: "Rank 23.5" },
				{ value: "23.4", displayName: "Rank 23.4" },
				{ value: "23.3", displayName: "Rank 23.3" },
				{ value: "22.0", displayName: "Rank 22(空)" },
				{ value: "22", displayName: "Rank 22(滿)" },
				{ value: "22.5", displayName: "Rank 22.5" },
				{ value: "22.4", displayName: "Rank 22.4" },
				{ value: "22.3", displayName: "Rank 22.3" },
				{ value: "21.0", displayName: "Rank 21(空)" },
				{ value: "21", displayName: "Rank 21(滿)" },
				{ value: "21.5", displayName: "Rank 21.5" },
				{ value: "21.4", displayName: "Rank 21.4" },
				{ value: "21.3", displayName: "Rank 21.3" },
				{ value: "20.0", displayName: "Rank 20(空)" },
				{ value: "20", displayName: "Rank 20(滿)" },
				{ value: "20.5", displayName: "Rank 20.5" },
				{ value: "20.4", displayName: "Rank 20.4" },
				{ value: "20.3", displayName: "Rank 20.3" },
				{ value: "19", displayName: "Rank 19(滿)" },
				{ value: "19.5", displayName: "Rank 19.5" },
				{ value: "19.4", displayName: "Rank 19.4" },
				{ value: "19.3", displayName: "Rank 19.3" },
				{ value: "18", displayName: "Rank 18(滿)" },
				{ value: "18.5", displayName: "Rank 18.5" },
				{ value: "18.4", displayName: "Rank 18.4" },
				{ value: "18.3", displayName: "Rank 18.3" },
				{ value: "17", displayName: "Rank 17(滿)" },
				{ value: "17.5", displayName: "Rank 17.5" },
				{ value: "17.4", displayName: "Rank 17.4" },
				{ value: "17.3", displayName: "Rank 17.3" },
				{ value: "16", displayName: "Rank 16(滿)" },
				{ value: "16.5", displayName: "Rank 16.5" },
				{ value: "16.4", displayName: "Rank 16.4" },
				{ value: "16.3", displayName: "Rank 16.3" },
				{ value: "15", displayName: "Rank 15(滿)" },
				{ value: "15.5", displayName: "Rank 15.5" },
				{ value: "15.4", displayName: "Rank 15.4" },
				{ value: "15.3", displayName: "Rank 15.3" },
				{ value: "14", displayName: "Rank 14(滿)" },
				{ value: "14.5", displayName: "Rank 14.5" },
				{ value: "14.4", displayName: "Rank 14.4" },
				{ value: "14.3", displayName: "Rank 14.3" },
				{ value: "13", displayName: "Rank 13(滿)" },
				{ value: "13.5", displayName: "Rank 13.5" },
				{ value: "13.4", displayName: "Rank 13.4" },
				{ value: "13.3", displayName: "Rank 13.3" },
				{ value: "12", displayName: "Rank 12(滿)" },
				{ value: "12.5", displayName: "Rank 12.5" },
				{ value: "12.4", displayName: "Rank 12.4" },
				{ value: "12.3", displayName: "Rank 12.3" },
				{ value: "11", displayName: "Rank 11(滿)" },
				{ value: "11.5", displayName: "Rank 11.5" },
				{ value: "11.4", displayName: "Rank 11.4" },
				{ value: "11.3", displayName: "Rank 11.3" },
				{ value: "10", displayName: "Rank 10(滿)" },
				{ value: "10.5", displayName: "Rank 10.5" },
				{ value: "10.4", displayName: "Rank 10.4" },
				{ value: "10.3", displayName: "Rank 10.3" },
				{ value: "9", displayName: "Rank 9(滿)" },
				{ value: "9.5", displayName: "Rank 9.5" },
				{ value: "9.4", displayName: "Rank 9.4" },
				{ value: "9.3", displayName: "Rank 9.3" },
				{ value: "8", displayName: "Rank 8(滿)" },
				{ value: "8.5", displayName: "Rank 8.5" },
				{ value: "8.4", displayName: "Rank 8.4" },
				{ value: "8.3", displayName: "Rank 8.3" },
			],
			heartCost: [
				{ lv: "1", cost: 30 },
				{ lv: "30", cost: 0 },
				{ lv: "50", cost: 5 },
				{ lv: "70", cost: 5 },
				{ lv: "90", cost: 8 },
				{ lv: "110", cost: 10 },
				{ lv: "130", cost: 10 },
				{ lv: "140", cost: 10 },
				{ lv: "150", cost: 10 },
				{ lv: "160", cost: 10 },
				{ lv: "170", cost: 10 },
				{ lv: "180", cost: 10 },
				{ lv: "190", cost: 10 },
				{ lv: "200", cost: 10 },
				{ lv: "210", cost: 10 },
				{ lv: "220", cost: 10 },
				{ lv: "230", cost: 10 },
				{ lv: "240", cost: 10 },
				{ lv: "250", cost: 10 },
				{ lv: "260", cost: 10 },
				{ lv: "270", cost: 10 },
				{ lv: "280", cost: 10 },
				{ lv: "290", cost: 10 },
				{ lv: "300", cost: 10 },
			],
			mapTarget: {},
			promotion_level_top: 33,
			mapTop: 70,
			uqTop: "300",
			ignoreEqRank: true,
			filterEqRank: 104000,
			showSubDrop: false,
			totalCost: 0,
			dropRate: 1,
			memoryPiecesList: [],
			itemList: [],
			mapList: [],
			mapHardList: [],
			myMap: [],
			editTeamList: [],
			equipmentReduce: ReduceEq,
			equipmentReduce2019: ReduceEq2019,
			equipmentCraft: [],
			oldVersion: false,
			oldVersion2019: false,
			dropRateUpdate: true,
			popMsg: {
				title: "",
				content: "",
			},
		};
	},
	metaInfo: {
		title: "裝備庫",
		// all titles will be injected into this template
		titleTemplate: "%s | 蘭德索爾圖書館 公主連結 Wiki",
		meta: [{ charset: "utf-8" }, { name: "description", content: "使用蘭德索爾圖書館的裝備庫自動計算需要的裝備及建議刷裝地圖。" }],
	},
	watch: {
		filterUnitName: function(val) {
			var self = this;
			this.star3 = _.forEach(this.star3, function(o) {
				if (
					o.name.includes(self.filterUnitName) ||
					o.jp_name.includes(self.filterUnitName) ||
					o.en_name.toLowerCase().includes(self.filterUnitName.toLowerCase())
				) {
					o.show = true;
				} else {
					o.show = false;
				}
			});
			this.star2 = _.forEach(this.star2, function(o) {
				if (
					o.name.includes(self.filterUnitName) ||
					o.jp_name.includes(self.filterUnitName) ||
					o.en_name.toLowerCase().includes(self.filterUnitName.toLowerCase())
				) {
					o.show = true;
				} else {
					o.show = false;
				}
			});
			this.star1 = _.forEach(this.star1, function(o) {
				if (
					o.name.includes(self.filterUnitName) ||
					o.jp_name.includes(self.filterUnitName) ||
					o.en_name.toLowerCase().includes(self.filterUnitName.toLowerCase())
				) {
					o.show = true;
				} else {
					o.show = false;
				}
			});
			this.$forceUpdate();
		},
	},
	methods: {
		getTalentId: function(unit_id) {
			var self = this
			var unitTalent = JSON.parse(self.atou(unit_talent));
			const talentUnit = unitTalent.find(obj => obj.unit_id == _.toInteger(unit_id));
			return talentUnit.talent_id
		},
		isFiltered: function(eq_id) {
			let eqName = this.getEqName(eq_id)
			return _.includes(this.filterEqList, eqName);
		},
		startExportImage: function() {
			var self = this;
			route;
		},
		clearFilterEqList: function() {
			this.filterEqList = [];
		},
		addMapFilter: function(eq_id) {
			let eqName = this.getEqName(eq_id)
			if (_.includes(this.filterEqList, eqName)) {
				var key = _.findKey(this.filterEqList, function(o) {
					return o == eqName;
				});
				this.$delete(this.filterEqList, key);
			} else {
				this.filterEqList.push(eqName);
			}
		},
		pageCallback: function(page) {
			var vm = this;
			this.$set(vm, "currentPage", page);
		},
		debounceInput: _.debounce(function(e) {
			this.filterUnitName = e.target.value;
		}, 1000),
		getI18nName: function(item, name) {
			switch (this.locale) {
				case "en":
					return item["en_" + name];
					break;
				case "jp":
					return item["jp_" + name];
					break;
				default:
					return item[name];
					break;
			}
		},
		selectCharacter: function(item) {
			var self = this;
			this.selectUnit = item;
		},
		debounceInputFilterEq: _.debounce(function(e) {
			this.filterEq = e.target.value;
		}, 500),
		rankAllActive: function(index) {
			this.rankAll.rList[index].active = !this.rankAll.rList[index].active;
		},
		rankTargetActive: function(index) {
			this.rankTarget.rList[index].active = !this.rankTarget.rList[index].active;
		},
		equipmentSubtraction: function(item) {
			var self = this;
			_.forEach(item, function(j) {
				var key = _.findKey(self.itemList, function(o) {
					return o.equipment_id == j.id;
				});
				if (!key) {
					return;
				}
				var inventory = self.itemList[key];
				inventory.count = Number(inventory.count) - Number(j.consume);
				if (inventory.count <= 0) {
					inventory.count = 0;
				}
				self.$set(self.itemList, key, inventory);
			});
		},
		eqActive: function(value, eqSlot) {
			var self = this;
			var unit = this.selectUnit;
			var index = Number(unit.promotion_level) - 1;
			this.selectUnit.eqList[index][eqSlot].active = true;
			if (this.autoSubtraction) {
				var tree = this.getIncludeEq(value);
				var eqTree = [];

				function deepPick(item) {
					if (item.children.length > 0) {
						_.forEach(item.children, function(o) {
							deepPick(o);
						});
					} else {
						var obj = {};
						obj.id = item.parent_id;
						obj.consume = item.consume;
						eqTree.push(obj);
					}
				}
				try {
					var success = true;
					deepPick(tree);
				} catch (e) {
					success = false;
				}
				if (success && eqTree.length > 0) {
					this.equipmentSubtraction(eqTree);
				}
			}
		},
		getIncludeEq: function(itemId) {
			var self = this;
			var eq = _.find(self.equipmentCraft, ["equipment_id", itemId]);
			if (!eq) {
				return;
			}
			var list = self.findTreeEq(itemId);
			return list;
		},
		findTreeEq: function(itemId, consume) {
			var self = this;
			var eq = _.find(self.equipmentCraft, ["equipment_id", itemId]);
			let data = {
				parent_id: itemId,
				consume: consume,
				children: [],
			};
			if (!eq) {
				return data;
			}
			var subEq = [{
					condition_equipment_id: eq.condition_equipment_id_1,
					consume_num: eq.consume_num_1,
				},
				{
					condition_equipment_id: eq.condition_equipment_id_2,
					consume_num: eq.consume_num_2,
				},
				{
					condition_equipment_id: eq.condition_equipment_id_3,
					consume_num: eq.consume_num_3,
				},
				{
					condition_equipment_id: eq.condition_equipment_id_4,
					consume_num: eq.consume_num_4,
				},
			];

			subEq = _.filter(subEq, function(o) {
				return o.consume_num != "0";
			});
			if (subEq.length == 0) {
				return data;
			}
			_.forEach(subEq, function(item) {
				data["children"].push(self.findTreeEq(item.condition_equipment_id, item.consume_num));
			});
			return data;
		},
		eqRemove: function(value, eqSlot) {
			var unit = this.selectUnit;
			var index = Number(unit.promotion_level) - 1;
			this.selectUnit.eqList[index][eqSlot].active = false;
		},
		changeRank: function() {
			var rankIndex = Number(this.selectUnit.promotion_level) - 1;
			this.selectUnit.promotion_level = Number(this.selectUnit.promotion_level);
			_.forEach(this.selectUnit.eqList, function(value, key) {
				if (key < rankIndex) {
					for (var i = 1; i <= 6; i++) {
						value["equip_slot_" + i]["active"] = true;
					}
				} else {
					for (var i = 1; i <= 6; i++) {
						value["equip_slot_" + i]["active"] = false;
					}
				}
			});
		},
		getCharaImg: function(unit_id) {
			return `background-image: url(/static/images/unit_small/${unit_id}.png)`;
		},
		getCharaName: function(unit_id) {
			var unit = _.find(this.$store.getters.getUnitData, ["unit_id", unit_id]);
			if (unit) {
				return this.getI18nName(unit, "kana");
			}
			return "";
		},
		changeRarity: function(value) {},
		changeFilter: function(item) {
			if (this.filterPosition != item) {
				this.filterPosition = item;
				localStorage.setItem("filterPosition", item.toString());
				this.orderDesc = true;
				localStorage.setItem("orderDesc", this.orderDesc.toString());
			} else {
				this.orderDesc = !this.orderDesc;
				localStorage.setItem("orderDesc", this.orderDesc.toString());
			}
		},
		reverseKeys(n) {
			return [...Array(n).keys()].slice().reverse();
		},
		itemDisable: function(item) {
			var key = _.findKey(this.itemList, function(o) {
				return o.equipment_id == item.equipment_id;
			});
			var item = item;
			item.active = item.active == "1" ? "0" : "1";
			this.$set(this.itemList, key, item);
		},
		deleteUnit: function(value) {
			var key = _.findKey(this.teamList, function(o) {
				return o.unit_id == value;
			});
			this.$delete(this.teamList, key);
			var reSelect = _.find(this.star3, ["id", value]);
			if (_.isEmpty(reSelect)) {
				var reSelect = _.find(this.star2, ["id", value]);
			}
			if (_.isEmpty(reSelect)) {
				var reSelect = _.find(this.star1, ["id", value]);
			}
			if (reSelect) {
				reSelect.select = false;
			}
		},
		checkTrace: function(value) {
			value = value.toString();
			switch (value) {
				case "true":
					return "Top";
					break;
				case "false":
					return "X";
					break;
				default:
					return value;
			}
		},
		checkStar: function(value) {
			switch (value) {
				case "2":
					return "star2";
					break;
				case "3":
					return "star3";
					break;
				case "4":
					return "star3";
					break;
				case "5":
					return "star3";
					break;
				default:
					return;
			}
		},
		checkPromo: function(value, isTrace) {
			if (isTrace == "false") {
				return "notTrace";
			}
			if (value >= 32) {
				return "p10";
			} else if (value < 32 && value >= 28) {
				return "p9";
			} else if (value < 28 && value >= 24) {
				return "p8";
			} else if (value < 24 && value >= 21) {
				return "p7";
			} else if (value < 21 && value >= 18) {
				return "p6";
			} else if (value < 18 && value >= 11) {
				return "p5";
			} else if (value < 11 && value >= 7) {
				return "p4";
			} else if (value < 7 && value > 3) {
				return "p3";
			} else if (value > 1 && value < 4) {
				return "p2";
			} else if (value == 1) {
				return "p1";
			}
		},
		leftOrRight: function(index) {
			switch (index) {
				case "equip_slot_3":
					return "left";
					break;
				case "equip_slot_4":
					return "text-right";
					break;
				default:
					return "text-center";
			}
		},
		backward: function(n) {
			var now;
			switch (n) {
				case 1:
					now = 3;
					return now;
					break;
				case 3:
					now = 1;
					return now;
					break;
				default:
					return n;
			}
		},
		joinTeam: function(id, index, rarity) {
			var self = this;
			var teamList = this.teamList;
			var thisUnit = _.find(self.$store.getters.getUnitData, ["unit_id", id]);
			var thisEquipment = new Array();
			thisEquipment = _.filter(self.$store.getters.getUnitPromotion, function(o) {
				return _.includes(o.unit_id, id);
			});			
			_.forEach(thisEquipment, function(o) {
				if (o["equip_slot_1"]["active"] == null) {
					o["equip_slot_1"] = { eq_id: o.equip_slot_1, active: false };
					o["equip_slot_2"] = { eq_id: o.equip_slot_2, active: false };
					o["equip_slot_3"] = { eq_id: o.equip_slot_3, active: false };
					o["equip_slot_4"] = { eq_id: o.equip_slot_4, active: false };
					o["equip_slot_5"] = { eq_id: o.equip_slot_5, active: false };
					o["equip_slot_6"] = { eq_id: o.equip_slot_6, active: false };
				}
			});
			var myUnit = new Object();
			try {
				myUnit["eqList"] = thisEquipment;
				myUnit["promotion_level"] = 1;
				myUnit["rarity"] = thisUnit.rarity;
				myUnit["unit_id"] = thisUnit.unit_id;
				myUnit["trace"] = true;
				myUnit["focus"] = false;
				myUnit["uqEq"] = "";
				myUnit["uqEq2"] = "";
				myUnit["lvBreak"] = "false";
				teamList.push(myUnit);
			} catch (e) {
				console.log(e);
			}
			this.teamList = teamList;
			self["star" + rarity][index].select = true;
		},
		getStarList: function(rarity) {
			var self = this;
			var list = _.filter(self.$store.getters.getUnitData, function(o) {
				return o.rarity == rarity;
			});
			var newList = new Array();
			list = _.forEach(list, function(value) {
				_.forEach(self.$store.getters.getCharaIdentity, function(o) {
					if (o.unit_id == value.unit_id) {
						o["rarity"] = value.rarity;
						o["id"] = value.unit_id;
						o["kana"] = value.kana;
						o["jp_name"] = value.jp_unit_name ? value.jp_unit_name : "none";
						o["name"] = value.unit_name ? value.unit_name : "none";
						o["en_name"] = value.en_unit_name ? value.en_unit_name : "none";
						o["show"] = true;
						o["select"] = false;
						o["search_area_width"] = Number(value.search_area_width);
						newList.push(o);
					}
				});
			});
			self["star" + rarity] = newList;
		},
		getItemList: function() {
			var self = this;
			let col = ["設計圖", "碎片", "欠片", "設計図"];
			var itemList = _.filter(self.$store.getters.getEquipmentData, function(o) {
				return _.some(col, (el) => _.includes(o.equipment_name, el) && Number(o.promotion_level) > 2);
			});
			itemList = _.map(itemList, function(o) {
				var obj = _.pick(o, ["promotion_level", "require_level", "equipment_id"]);
				if (_.isUndefined(obj.count)) {
					obj.count = 0;
				}
				if (_.isUndefined(obj.active)) {
					obj.active == 1;
				}
				return obj;
			});
			self.itemList = itemList;
		},
		getMPList: function() {
			var self = this;
			var unitMpList = [];
			var mp = [];
			if (localStorage.getItem("mpList") != null) {
				mp = JSON.parse(localStorage.getItem("mpList"));
			}
			for (var n = 1; n <= 3; n++) {
				var list = self["star" + n];
				_.forEach(list, function(o) {
					let unit = {};
					unit.unit_id = o.unit_id;
					unit.count = 0;
					if (mp) {
						var mpunit = _.find(mp, ["unit_id", o.unit_id]);
						if (mpunit) {
							unit.count = mpunit.count;
						}
					}
					unitMpList.push(unit);
				});
			}
			this.memoryPiecesList = unitMpList;

			// _.forEach
		},
		SyncEquipment: function(activeType) {
			var type = false;
			if (activeType) {
				type = true;
			}
			var self = this;
			var myTeamSnapShot = _.cloneDeep(this.teamList);
			var myTeam = this.teamList;
			_.forEach(myTeam, function(o, key) {
				try {
					var unitEquipment = _.filter(self.$store.getters.getUnitPromotion, function(j) {
						return _.includes(j.unit_id, o.unit_id);
					});
					_.forEach(unitEquipment, function(ue) {
						if (ue["equip_slot_1"]["active"] == null) {
							ue["equip_slot_1"] = { eq_id: ue.equip_slot_1, active: false };
							ue["equip_slot_2"] = { eq_id: ue.equip_slot_2, active: false };
							ue["equip_slot_3"] = { eq_id: ue.equip_slot_3, active: false };
							ue["equip_slot_4"] = { eq_id: ue.equip_slot_4, active: false };
							ue["equip_slot_5"] = { eq_id: ue.equip_slot_5, active: false };
							ue["equip_slot_6"] = { eq_id: ue.equip_slot_6, active: false };
						}
					});
					o["eqList"] = unitEquipment;
					var unitSnapShot = _.find(myTeamSnapShot, ["unit_id", o.unit_id]);
					if (unitSnapShot.promotion_level == o.promotion_level) {
						var pl = Number(o.promotion_level) - 1;
						o["eqList"][pl]["equip_slot_1"]["active"] = unitSnapShot["eqList"][pl]["equip_slot_1"]["active"];
						o["eqList"][pl]["equip_slot_2"]["active"] = unitSnapShot["eqList"][pl]["equip_slot_2"]["active"];
						o["eqList"][pl]["equip_slot_3"]["active"] = unitSnapShot["eqList"][pl]["equip_slot_3"]["active"];
						o["eqList"][pl]["equip_slot_4"]["active"] = unitSnapShot["eqList"][pl]["equip_slot_4"]["active"];
						o["eqList"][pl]["equip_slot_5"]["active"] = unitSnapShot["eqList"][pl]["equip_slot_5"]["active"];
						o["eqList"][pl]["equip_slot_6"]["active"] = unitSnapShot["eqList"][pl]["equip_slot_6"]["active"];
					}
				} catch (e) {
					console.log(o);
					console.log(e);
					console.log("同步失敗" + self.getCharaName(o.unit_id));
				}
			});
			if (type) {
				$("#popBox").modal();
				self.popMsg.title = "同步成功";
				self.popMsg.content = "如還是有不符合的情形，請移除角色再次加入。";
			}
		},
		saveTeam: function() {
			this.deleteUnit("170101");
			var teamList = JSON.stringify(this.teamList);
			var itemList = JSON.stringify(this.itemList);
			var mpList = JSON.stringify(this.memoryPiecesList);
			var slotSetting = JSON.stringify(this.slotSetting);
			var self = this;
			if (typeof Storage !== "undefined") {
				localStorage.setItem("itemList", itemList);
				localStorage.setItem("teamList", teamList);
				localStorage.setItem("slotSetting", slotSetting);
				localStorage.setItem("mpList", mpList);
				localStorage.setItem("slot1", self.zipMyTeam());
				$("#popBox").modal();
				self.popMsg.title = "儲存成功";
				self.popMsg.content = "儲存資料只會存在當前瀏覽器中。";
				localStorage.removeItem("tempSlot");
			} else {
				self.notSupport = true;
			}
		},
		b64EncodeUnicode: function(str) {
			return btoa(
				encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function toSolidBytes(match, p1) {
					return String.fromCharCode("0x" + p1);
				})
			);
		},
		freeze: function(item) {},
		exportUrl: function() {
			var self = this;
			$("#ExportBtn").prop("disabled", true);
			self.isLoading = true;
			if (!this.teamList) {
				this.exportNotice = "匯出失敗 沒有隊伍";
				return;
			}
			var uuid = this.uuid();
			var teamList = self.zipMyTeam();
			var url = "/static/php/mysqlAdd.php";
			var data = { teamList: teamList, uuid: uuid };
			$.ajax({
				type: "POST",
				url: url,
				data: data,
				success: function(data) {
					var res = data.toString().trim();
					if (res == "200") {
						self.isLoading = false;
						self.exportNotice = "https://pcredivewiki.tw/Armory?s=" + uuid;
					}
				},
				error: function(res) {
					this.exportNotice = "匯出失敗";
				},
			});
			setTimeout(function() {
				$("#ExportBtn").prop("disabled", false);
			}, 5000);
		},
		uuid: function() {
			var d = Date.now();
			if (typeof performance !== "undefined" && typeof performance.now === "function") {
				d += performance.now();
			}
			return "xxxxxxxx".replace(/[xy]/g, function(c) {
				var r = (d + Math.random() * 16) % 16 | 0;
				d = Math.floor(d / 16);
				return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
			});
		},
		checkUnitTrace: function(index) {
			//編輯角色內
			var unit = this.selectUnit;			
			var unitPromotion = unit?.promotion_level?.toString();

			if (unit.trace === unitPromotion + ".0") {
				return "d-none";
			}

			if (unit.trace == unitPromotion + ".3" && (index == "equip_slot_1" || index == "equip_slot_3" || index == "equip_slot_5")) {
				return "add";
			} else if (unit.trace == unitPromotion + ".4" && (index == "equip_slot_1" || index == "equip_slot_3")) {
				return "add";
			} else if (unit.trace == unitPromotion + ".5" && index == "equip_slot_1") {
				return "add";
			}
			return "d-none";
		},
		checkTraceClass: function(item, trace, promotion_level, index) {
			//外面顯示
			var pl = promotion_level.toString();
			var t3 = pl + ".3";
			var t4 = pl + ".4";
			var t5 = pl + ".5";
			var t0 = pl + ".0";
			trace = trace.toString();
			if (trace === t0) {
				return "notTrace";
			}
			if (trace === t3 && (index == "equip_slot_1" || index == "equip_slot_3" || index == "equip_slot_5")) {
				return "notTrace";
			}
			if (trace === t4 && (index == "equip_slot_1" || index == "equip_slot_3")) {
				return "notTrace";
			}
			if (trace === t5 && index == "equip_slot_1") {
				return "notTrace";
			}
			if (item.active) {
				return "active";
			} else {
				return "inactive";
			}
		},
		allCharaEdit: function() {
			var self = this;
			var rank = Number(this.rankAll.promotion_level);
			var rarity = this.rankAll.rarity;
			var trace = this.rankAll.trace;
			var uqEq = this.rankAll.uqEq;
			var team = this.teamList;
			var putEquipment = Number(this.rankAll.putEquipment);
			var snapshotTeam = new Array();
			_.forEach(team, function(o) {
				var obj = {};
				var snapshotTrace = o.trace.toString();
				obj["eqList"] = o.eqList[Number(o.promotion_level) - 1];
				obj["trace"] = o.trace;
				obj["unit_id"] = o.unit_id;
				snapshotTeam.push(obj);
			});
			_.forEach(team, function(o) {
				if (rank != 0) {
					o.promotion_level = rank;
				}
				if (rarity != 0) {
					o.rarity = rarity;
				}
				if (trace != 0) {
					var snapshot = _.find(snapshotTeam, ["unit_id", o.unit_id]);
					var oldtrace = snapshot.trace.toString();
					if (oldtrace == "true") {
						oldtrace = self.promotion_level_top.toString();
					}
					var oldTraceSub = oldtrace.split(".")[1];
					var oldTraceIndex = Math.floor(Number(oldtrace)) - 1;
					o.trace = trace;
					if (Number(o.trace) || o.trace.toString() == "true") {
						if (Math.floor(trace) == Math.floor(snapshot.trace) || Math.floor(trace) > Math.floor(snapshot.trace)) {
							if (oldtrace.split(".").length > 1) {
								o.eqList[oldTraceIndex]["equip_slot_2"].active = snapshot.eqList.equip_slot_2.active;
								o.eqList[oldTraceIndex]["equip_slot_4"].active = snapshot.eqList.equip_slot_4.active;
								o.eqList[oldTraceIndex]["equip_slot_6"].active = snapshot.eqList.equip_slot_6.active;
								if (oldTraceSub == "3") {
									o.eqList[oldTraceIndex]["equip_slot_1"].active = false;
									o.eqList[oldTraceIndex]["equip_slot_3"].active = false;
									o.eqList[oldTraceIndex]["equip_slot_5"].active = false;
								} else if (oldTraceSub == "4") {
									o.eqList[oldTraceIndex]["equip_slot_1"]["active"] = false;
									o.eqList[oldTraceIndex]["equip_slot_3"]["active"] = false;
								} else if (oldTraceSub == "5") {
									o.eqList[oldTraceIndex]["equip_slot_1"]["active"] = false;
								}
							}
						}
					}
				}
				if (uqEq != 0) {
					o.uqEq = uqEq;
				}
				if (putEquipment != 0 && rank != 0) {
					_.forEach(o.eqList, function(eq, index) {
						if (rank - 1 > index) {
							for (var i = 1; i <= 6; i++) {
								eq["equip_slot_" + i].active = true;
							}
						}
						if (rank - 1 == index) {
							for (var i = 1; i <= 6; i++) {
								eq["equip_slot_" + i].active = self.rankAll.rList[i - 1].active;
							}
						}
						if (rank - 1 < index) {
							for (var i = 1; i <= 6; i++) {
								eq["equip_slot_" + i].active = false;
							}
						}
					});
				}
			});
			snapshotTeam = new Array();
		},
		clearEditTarget: function() {
			var self = this;
			_.forEach(self.editTeamList, function(object, index) {
				object.active = false;
				self.$set(self.editTeamList, index, object);
			});
		},
		targetRankTop: function() {
			var self = this;
			var rank = Number(this.rankTarget.promotion_level);
			var editTeam = _.filter(this.editTeamList, function(o) {
				return o.active;
			});
			editTeam = _.map(editTeam, "unit_id");
			var rarity = this.rankTarget.rarity;
			var trace = this.rankTarget.trace;
			var uqEq = this.rankTarget.uqEq;
			var team = this.teamList;
			var snapshotTeam = new Array();
			_.forEach(team, function(o) {
				var obj = {};
				var snapshotTrace = o.trace.toString();
				obj["eqList"] = o.eqList[Number(o.promotion_level) - 1];
				obj["trace"] = o.trace;
				obj["unit_id"] = o.unit_id;
				snapshotTeam.push(obj);
			});
			var putEquipment = Number(this.rankTarget.putEquipment);
			_.forEach(team, function(o) {
				if (!_.includes(editTeam, o.unit_id)) {
					return;
				}
				if (rank != 0) {
					o.promotion_level = rank;
				}
				if (rarity != 0) {
					o.rarity = rarity;
				}
				if (trace != 0) {
					var snapshot = _.find(snapshotTeam, ["unit_id", o.unit_id]);
					var oldtrace = snapshot.trace.toString();
					if (oldtrace == "true") {
						oldtrace = self.promotion_level_top.toString();
					}
					var oldTraceSub = oldtrace.split(".")[1];
					var oldTraceIndex = Math.floor(Number(oldtrace)) - 1;
					o.trace = trace;
					if (Number(o.trace) || o.trace.toString() == "true") {
						if (Math.floor(trace) == Math.floor(snapshot.trace) || Math.floor(trace) > Math.floor(snapshot.trace)) {
							if (oldtrace.split(".").length > 1) {
								o.eqList[oldTraceIndex]["equip_slot_2"].active = snapshot.eqList.equip_slot_2.active;
								o.eqList[oldTraceIndex]["equip_slot_4"].active = snapshot.eqList.equip_slot_4.active;
								o.eqList[oldTraceIndex]["equip_slot_6"].active = snapshot.eqList.equip_slot_6.active;
								if (oldTraceSub == "3") {
									o.eqList[oldTraceIndex]["equip_slot_1"].active = false;
									o.eqList[oldTraceIndex]["equip_slot_3"].active = false;
									o.eqList[oldTraceIndex]["equip_slot_5"].active = false;
								} else if (oldTraceSub == "4") {
									o.eqList[oldTraceIndex]["equip_slot_1"]["active"] = false;
									o.eqList[oldTraceIndex]["equip_slot_3"]["active"] = false;
								} else if (oldTraceSub == "5") {
									o.eqList[oldTraceIndex]["equip_slot_1"]["active"] = false;
								}
							}
						}
					}
				}
				if (uqEq != 0) {
					o.uqEq = uqEq;
				}
				if (putEquipment != 0 && rank != 0) {
					_.forEach(o.eqList, function(eq, index) {
						if (rank - 1 > index) {
							for (var i = 1; i <= 6; i++) {
								eq["equip_slot_" + i].active = true;
							}
						}
						if (rank - 1 == index) {
							for (var i = 1; i <= 6; i++) {
								eq["equip_slot_" + i].active = self.rankTarget.rList[i - 1].active;
							}
						}
						if (rank - 1 < index) {
							for (var i = 1; i <= 6; i++) {
								eq["equip_slot_" + i].active = false;
							}
						}
					});
				}
			});
		},
		deleteTeam: function() {
			var self = this;
			this.teamList = [];
			this.itemList = [];
			self.getItemList();
			_.forEach(self.star3, function(o) {
				o.select = false;
			});
			_.forEach(self.star2, function(o) {
				o.select = false;
			});
			_.forEach(self.star1, function(o) {
				o.select = false;
			});
			localStorage.removeItem("teamList");
			localStorage.removeItem("itemList");
			localStorage.removeItem("mpList");
			self.lzw = "";
		},
		loadItem: function() {
			var self = this;
			var featureItem = self.itemList;
			var nowItem = JSON.parse(localStorage.getItem("itemList"));
			featureItem = _.forEach(featureItem, function(o) {
				var thisItem = _.find(nowItem, ["equipment_id", Number(o.equipment_id)]);
				if (!thisItem) {
					return;
				}
				o.count = thisItem.count;
				if (_.isEmpty(thisItem.active)) {
					o.active = "1";
				} else {
					o.active = thisItem.active;
				}
			});
			self.itemList = featureItem;
		},
		loadTeam: function() {
			var self = this;
			var uuid = this.$route.query.s;

			function atou(str) {
				return decodeURIComponent(escape(window.atob(str)));
			}

			function dispatch(myteam) {
				var myTeam = myteam;
				_.forEach(myTeam, function(o) {
					try {
						var reSelect = _.find(self.star3, ["id", o.unit_id]);
						if (_.isEmpty(reSelect)) {
							var reSelect = _.find(self.star2, ["id", o.unit_id]);
						}
						if (_.isEmpty(reSelect)) {
							var reSelect = _.find(self.star1, ["id", o.unit_id]);
						}
						reSelect.select = true;

						if (_.isUndefined(o.trace)) {
							o.trace = "true";
						}
						if (_.isUndefined(o.focus)) {
							o.focus = false;
						}
					} catch (e) {}
				});
				var unitPromo = _.filter(self.$store.getters.getUnitPromotion, function(o) {
					return _.includes(o.unit_id, "102901");
				});
				var nowRank = unitPromo.length;
				var previousRank = nowRank - 1;
				var nowRankIndex = nowRank - 1;
				var previousRankIndex = nowRank - 2;
				//check新的第三五格
				if (unitPromo[nowRankIndex].equip_slot_3 != "999999") {
					_.forEach(myTeam, function(o, key) {
						var unitEq = new Array();
						unitEq = _.filter(self.$store.getters.getUnitPromotion, function(j) {
							return _.includes(j.unit_id, o.unit_id);
						});
						if (_.isEmpty(unitEq)) {
							return;
						}
						if (!_.isEmpty(o.eqList[nowRankIndex])) {
							o.eqList[nowRankIndex].equip_slot_3.eq_id = unitEq[nowRankIndex].equip_slot_3;
						}
					});
				}
				if (unitPromo[nowRankIndex].equip_slot_5 != "999999") {
					_.forEach(myTeam, function(o, key) {
						var unitEq = new Array();
						unitEq = _.filter(self.$store.getters.getUnitPromotion, function(j) {
							return _.includes(j.unit_id, o.unit_id);
						});
						if (_.isEmpty(unitEq)) {
							return;
						}
						if (!_.isEmpty(o.eqList[nowRankIndex])) {
							o.eqList[nowRankIndex].equip_slot_5.eq_id = unitEq[nowRankIndex].equip_slot_5;
						}
					});
				}
				var isOld = _.filter(myTeam, function(o) {
					if (o.eqList.length == 0) {
						return;
					}
					return o.eqList.length < nowRank;
				});
				if (isOld) {
					//儲存舊的資料且新開階級
					_.forEach(myTeam, function(o, key) {
						var unitEqLatest = new Array();
						unitEqLatest = _.filter(self.$store.getters.getUnitPromotion, function(j) {
							return _.includes(j.unit_id, o.unit_id);
						});

						if (_.isEmpty(unitEqLatest)) {
							return;
						}
						if (o.eqList.length == nowRank) {
							return;
						}
						var lastEq = _.last(unitEqLatest);
						var newEq = {};
						for (var i = 1; i <= 6; i++) {
							newEq["equip_slot_" + i] = { eq_id: lastEq["equip_slot_" + i], active: false };
						}
						newEq["promotion_level"] = unitPromo.length;
						newEq["unit_id"] = o.unit_id;
						o.eqList.push(newEq);
					});
				}
				//check新開階級第一格
				_.forEach(myTeam, function(o, key) {
					if (o.eqList.length == 0) {
						return;
					}
					if (o.eqList[previousRankIndex] && o.eqList[previousRankIndex].equip_slot_1.eq_id == "999999") {
						var unitEq = _.filter(self.$store.getters.getUnitPromotion, function(j) {
							return _.includes(j.unit_id, o.unit_id);
						});
						if (_.isEmpty(unitEq)) {
							return;
						}
						o.eqList[previousRankIndex].equip_slot_1.eq_id = unitEq[previousRankIndex].equip_slot_1;
					}
				});
				var promotion_level_top = Number(self.promotion_level_top);
				_.forEach(myTeam, function(o, key) {
					if (o.eqList.length > promotion_level_top) {
						o.eqList = _.slice(o.eqList, 0, promotion_level_top - 1);
					}
				});
				self.teamList = myTeam;
				self.$nextTick(() => {
					self.SyncEquipment();
				});
			}

			var myTeam = {};
			if (!_.isEmpty(uuid)) {
				self.isLoading = true;
				var url = "/static/php/mysqlGet.php";
				var data = { uuid: uuid };
				$.ajax({
					type: "POST",
					url: url,
					data: data,
					success: function(data) {
						var res = data.trim();
						try {
							myTeam = _.chunk(JSON.parse(atou(res)));
							dispatch(myTeam[0][0]);
							self.itemList = myTeam[1][0];
						} catch (e) {
							console.log("New Type");
							self.importTxt = res;
							self.importText();
						}
						history.pushState(null, "", location.href.split("?")[0]);
					},
					error: function(e) {
						this.exportNotice = "匯出失敗";
					},
				});
			} else {
				myTeam = JSON.parse(localStorage.getItem("teamList"));
				dispatch(myTeam);
			}
		},
		getQuestNumber: function(name, area_id) {
			name = name.split(/\s+/);
			var questName = name[1];
			if (area_id) {
				if (area_id > 12000 && area_id < 13000) {
					questName = "H<br>" + name[1];
				} else if (area_id > 13000 && area_id < 14000) {
					questName = "VH<br>" + name[1];
				}
			}

			return questName;
		},
		getEqName: function(eq_id) {
			var self = this;
			var eq = _.find(self.equipmentCraft, function(o) {
				return o.condition_equipment_id_1 == eq_id;
			});
			if (eq) {
				var eqData = _.find(self.$store.getters.getEquipmentData, function(o) {
					return o.equipment_id == eq.equipment_id;
				});
				return eqData.equipment_name;
			} else {
				try {
					var eqData = _.find(self.$store.getters.getEquipmentData, function(o) {
						return o.equipment_id == eq_id;
					});
					return eqData.equipment_name;
				} catch (e) {
					console.log(e);
				}
			}
		},
		getEqId: function(eq_id) {
			var self = this;
			var eq = _.find(self.equipmentCraft, function(o) {
				return o.condition_equipment_id_1 == eq_id;
			});
			if (eq) {
				return eq.equipment_id;
			}
		},
		setFilterEqSubDropName: function(eqName, eq_id) {
			if (eqName) {
				this.filterEq = eqName;
			} else {
				var obj = this.findName(eq_id);
				this.filterEq = obj.equipment_name ? obj.equipment_name : "";
			}
			this.pageCallback(1);
		},
		findName: function(eq_id) {
			var item = _.find(this.$store.getters.getEquipmentData, ["equipment_id", eq_id]);
			if (item) {
				let obj = {};
				obj.equipment_name = item.equipment_name;
				obj.en_equipment_name = item.en_equipment_name;
				obj.jp_equipment_name = item.jp_equipment_name;
				return obj;
			} else {
				return "";
			}
		},
		showDetail: function() {
			this.eqDetail = !this.eqDetail;
		},
		showItemOrder: function() {
			this.editItemOrder = !this.editItemOrder;
		},
		showCraft: function() {
			this.eqCraft = !this.eqCraft;
		},
		changeDisplayMode: function(mode) {
			this.displayMode = Number(mode);
			this.fastChangeStock = false;
		},
		showOverflow: function() {
			this.hiddenOverflow = !this.hiddenOverflow;
		},
		changeShowRank: function() {
			this.ignoreEqRank = !this.ignoreEqRank;
			var show = this.ignoreEqRank;
			localStorage.setItem("ignoreEqRank", show.toString());
		},
		changeFilterEqRank: function(rank) {
			this.filterEqRank = rank;
			localStorage.setItem("filterEqRank", rank.toString());
		},
		saveMapTop: function() {
			var self = this;
			var mapTop = self.filterMapTop;
			localStorage.setItem("mapTop", mapTop);
		},
		showUnitEq: function() {
			this.fastSee = !this.fastSee;
			localStorage.setItem("fastSee", this.fastSee);
		},
		changeAutoSubtraction: function() {
			this.autoSubtraction = !this.autoSubtraction;
			var as = this.autoSubtraction;
			localStorage.setItem("autoSubtraction", as.toString());
		},
		activeSlot: function(item) {
			this.tempSlotData = item;
			$("#LoadSlotTeam").modal();
		},
		loadSlotTeam: function() {
			this.currentSlot = this.tempSlotData.id;
		},
		editSlotName: function() {
			var slotId = this.tempSlotData.id;
			var inputName = this.$refs["SlotName"].value;
			this.tempSlotData.name = inputName;
			_.find(this.slotSetting, ["id", slotId]).name = inputName;
		},
		enter(element) {
			const width = getComputedStyle(element).width;

			element.style.width = width;
			element.style.position = "absolute";
			element.style.visibility = "hidden";
			element.style.height = "auto";

			const height = getComputedStyle(element).height;

			element.style.width = null;
			element.style.position = null;
			element.style.visibility = null;
			element.style.height = 0;

			// Force repaint to make sure the
			// animation is triggered correctly.
			getComputedStyle(element).height;

			// Trigger the animation.
			// We use `requestAnimationFrame` because we need
			// to make sure the browser has finished
			// painting after setting the `height`
			// to `0` in the line above.
			requestAnimationFrame(() => {
				element.style.height = height;
			});
		},
		afterEnter(element) {
			element.style.height = "auto";
		},
		leave(element) {
			const height = getComputedStyle(element).height;

			element.style.height = height;

			// Force repaint to make sure the
			// animation is triggered correctly.
			getComputedStyle(element).height;

			requestAnimationFrame(() => {
				element.style.height = 0;
			});
		},
		countRecipe: function(item) {
			var myItem = _.find(this.itemList, ["equipment_id", Number(item.eq_craft)]);
			if (item.eq_craft == "103613") {
				myItem = _.find(this.itemList, ["equipment_id", "103611"]);
			}
			if (!myItem) {
				return;
			}
			var lack = item.count - myItem.count;
			return lack;
		},
		countRecipeHtml: function(item) {
			var myItem = _.find(this.itemList, ["equipment_id", Number(item.eq_craft)]);
			if (item.eq_craft == "103613") {
				myItem = _.find(this.itemList, ["equipment_id", "103611"]);
			}
			if (!myItem) {
				return;
			}
			var lack = item.count - myItem.count;
			var badge = "badge-danger";
			var isLack = this.$t("Lack");
			if (lack < 0) {
				lack = Math.abs(lack);
				isLack = this.$t("Spare");
				badge = "badge-pill badge-green";
			}
			return `${this.$t("Need")}：${item.count}<br>${this.$t("Inventory")}：${
                myItem.count
            }<br>${isLack}：<span class="badge my-1 ${badge}">${lack}</span></div>`;
		},
		getSubEquipment: function(equipmentList, subList, key) {
			var self = this;
			_.forEach(subList, function(equipment_id) {
				var thisEqKey = equipmentList[equipment_id];
				if (thisEqKey) {
					var existLength = equipmentList[key].length;
					for (var k = 1; k <= existLength; k++) {
						thisEqKey.push({ active: false, eq_id: key, unit: "eq" + key });
					}
				} else {
					var eqObj = [{ active: false, eq_id: key, unit: "eq" + key }];
					equipmentList[equipment_id] = eqObj;
					var thisLeght = equipmentList[key] == null ? 0 : equipmentList[key].length;
					if (thisLeght > 1) {
						for (var j = 1; j <= thisLeght - 1; j++) {
							equipmentList[equipment_id].push({ active: false, eq_id: key, unit: "eq" + key });
						}
					}
				}
			});
			return equipmentList;
		},
		findSubEq: function(itemId) {
			var self = this;
			var data = new Array();
			if (itemId == "103613") {
				itemId = "103611";
			}
			var eq = _.find(self.equipmentCraft, ["equipment_id", itemId]);
			if (!eq) {
				return null;
			}
			var subEq = [eq.condition_equipment_id_2, eq.condition_equipment_id_3, eq.condition_equipment_id_4];
			subEq = _.filter(subEq, function(o) {
				return o != "0";
			});

			if (_.isEmpty(subEq)) {
				return (data = _.concat(data, subEq));
			}
			_.forEach(subEq, function(subItem) {
				data = _.concat(data, self.findSubEq(subItem));
			});
			data = _.concat(data, subEq);
			data = _.filter(data, function(o) {
				return o != null;
			});
			return data;
		},
		getMapList: function() {
			var self = this;
			var questRewardList = _.filter(self.$store.getters.getQuestData, function(o) {
				return Number(o.area_id) < 12000;
			});
			var mapRewardList = new Array();
			_.forEach(questRewardList, function(value, index) {
				var waveGroupList = new Array();
				var waveDropList = new Array();
				var questDropItemList = new Array();
				var wg1, wg2, wg3;
				wg1 = _.find(self.$store.getters.getWaveGroupData, ["wave_group_id", value.wave_group_id_1]);
				wg2 = _.find(self.$store.getters.getWaveGroupData, ["wave_group_id", value.wave_group_id_2]);
				wg3 = _.find(self.$store.getters.getWaveGroupData, ["wave_group_id", value.wave_group_id_3]);
				waveGroupList.push(wg1, wg2, wg3);
				var enemyRewardList = new Array();
				_.forEach(waveGroupList, function(drop) {
					for (var i = 0; i <= 4; i++) {
						try {
							if (!_.isNil(drop) && drop["drop_reward_id_" + (i + 1)] != 0) {
								enemyRewardList.push(drop["drop_reward_id_" + (i + 1)]);
							}
						} catch (e) {
							console.log(e);
						}
					}
				});
				_.forEach(enemyRewardList, function(ememyReward) {
					var erd;
					erd = _.find(self.$store.getters.getEnemyRewardData, ["drop_reward_id", ememyReward]);
					for (var i = 0; i <= 4; i++) {
						if (erd["reward_id_" + (i + 1)] != 0 && erd["reward_type_" + (i + 1)] == "4") {
							var dObj = {};
							dObj["reward_id"] = erd["reward_id_" + (i + 1)];
							dObj["eq_id"] = self.getEqId(erd["reward_id_" + (i + 1)]);
							dObj["odds"] = erd["odds_" + (i + 1)];
							if (self.dropRateUpdate == true) {
								switch (erd["odds_" + (i + 1)]) {
									case "54":
										dObj["odds"] = "36";
										break;
									case "36":
										dObj["odds"] = "24";
										break;
								}
							}
							dObj["reward_name"] = self.getEqName(erd["reward_id_" + (i + 1)]);
							let item = _.find(self.$store.getters.getEquipmentData, ["equipment_id", dObj["reward_id"]]);
							if (item) {
								dObj["promotion_level"] = item.promotion_level;
							} else {
								dObj["promotion_level"] = "1";
							}
							dObj["order"] = 0;
							questDropItemList.push(dObj);
						}
					}
				});
				questDropItemList = _.orderBy(questDropItemList, ["odds", "eq_id"], ["desc", "desc"]);

				function promote(foo, arr) {
					for (var i = 0; i < arr.length; i++) {
						if (arr[i].reward_id === foo) {
							var a = arr.splice(i, 1); // removes the item
							arr.unshift(a[0]); // adds it back to the beginning
							break;
						}
					}
					// Matching item wasn't found. Array is unchanged, but you could do something
					// else here if you wish (like an error message).
				}
				for (let i = 5; i >= 0; i--) {
					if (value["reward_image_" + i] != 0) {
						promote(value["reward_image_" + i], questDropItemList);
					}
				}
				var mapObj = {
					quest_name: "",
					quest_drop_item_list: [],
				};
				if (Number(value.area_id) >= 11037) {
					var currentMap = value.area_id.slice(-2);
					var dropList;

					if (Number(currentMap) >= 63) {
						if (Number(value.quest_id.slice(-2)) <= 5) {
							dropList = ExtraDrop[currentMap + ".5"];
						} else {
							dropList = ExtraDrop[currentMap + ".10"];
						}
					} else if (Number(currentMap) < 63 && Number(currentMap) >= 58) {
						if (Number(value.quest_id.slice(-2)) <= 7) {
							dropList = ExtraDrop[currentMap + ".7"];
						} else {
							dropList = ExtraDrop[currentMap + ".14"];
						}
					} else {
						dropList = ExtraDrop[currentMap];
					}

					_.forEach(dropList, function(o) {
						o["odds"] = (100 / dropList.length).toFixed(2);
					});
					mapObj.subDropItemList = dropList;
				}
				mapObj.quest_name = self.getQuestNumber(value.quest_name);
				mapObj.quest_drop_item_list = questDropItemList;
				mapObj.stamina = value.stamina;
				mapRewardList.push(mapObj);
			});
			self.mapList = mapRewardList;
			self.$nextTick(() => {
				self.isLoading = false;
			});
		},
		getHardMapList: function() {
			var self = this;
			var questRewardList = _.filter(self.$store.getters.getQuestData, function(o) {
				return Number(o.area_id) > 12000 && o.area_id < 14000;
			});
			var mapRewardList = new Array();
			_.forEach(questRewardList, function(value, index) {
				var waveGroupList = new Array();
				var waveDropList = new Array();
				var questDropItemList = new Array();
				var wg1, wg2, wg3;
				wg1 = _.find(self.$store.getters.getWaveGroupData, ["wave_group_id", value.wave_group_id_1]);
				wg2 = _.find(self.$store.getters.getWaveGroupData, ["wave_group_id", value.wave_group_id_2]);
				wg3 = _.find(self.$store.getters.getWaveGroupData, ["wave_group_id", value.wave_group_id_3]);
				waveGroupList.push(wg1, wg2, wg3);
				var enemyRewardList = new Array();
				_.forEach(waveGroupList, function(drop) {
					for (var i = 0; i <= 4; i++) {
						try {
							if (drop && drop["drop_reward_id_" + (i + 1)] != 0) {
								enemyRewardList.push(drop["drop_reward_id_" + (i + 1)]);
							}
						} catch (e) {
							console.log(e);
						}
					}
				});
				_.forEach(enemyRewardList, function(ememyReward) {
					var erd;
					erd = _.find(self.$store.getters.getEnemyRewardData, ["drop_reward_id", ememyReward]);
					for (var i = 0; i <= 4; i++) {
						if (erd["reward_id_" + (i + 1)] != 0 && erd["reward_type_" + (i + 1)] == "4") {
							var dObj = {};
							dObj["reward_id"] = erd["reward_id_" + (i + 1)];
							dObj["eq_id"] = self.getEqId(erd["reward_id_" + (i + 1)]);
							dObj["odds"] = erd["odds_" + (i + 1)];
							dObj["reward_name"] = self.getEqName(erd["reward_id_" + (i + 1)]);
							let item = _.find(self.$store.getters.getEquipmentData, ["equipment_id", dObj["reward_id"]]);
							if (item) {
								dObj["promotion_level"] = item.promotion_level;
							} else {
								dObj["promotion_level"] = "1";
							}
							dObj["order"] = 0;
							questDropItemList.push(dObj);
						}
						if (
							erd["reward_id_" + (i + 1)] != 0 &&
							erd["reward_type_" + (i + 1)] == "2" &&
							Number(erd["reward_id_" + (i + 1)]) > 31000 &&
							Number(erd["reward_id_" + (i + 1)]) < 33000
						) {
							var dObj = {};
							dObj["reward_id"] = erd["reward_id_" + (i + 1)];
							dObj["reward_type"] = erd["reward_type_" + (i + 1)];
							questDropItemList.push(dObj);
						}
					}
				});
				questDropItemList = _.orderBy(questDropItemList, ["odds", "eq_id"], ["desc", "desc"]);

				function promote(foo, arr) {
					for (var i = 0; i < arr.length; i++) {
						if (arr[i].reward_id === foo) {
							var a = arr.splice(i, 1); // removes the item
							arr.unshift(a[0]); // adds it back to the beginning
							break;
						}
					}
					// Matching item wasn't found. Array is unchanged, but you could do something
					// else here if you wish (like an error message).
				}
				for (let i = 5; i >= 0; i--) {
					if (value["reward_image_" + i] != 0) {
						promote(value["reward_image_" + i], questDropItemList);
					}
				}
				var mapObj = {
					quest_name: "",
					quest_drop_item_list: [],
				};
				mapObj.quest_name = self.getQuestNumber(value.quest_name, value.area_id);
				mapObj.quest_drop_item_list = questDropItemList;
				mapObj.stamina = value.stamina;
				mapRewardList.push(mapObj);
			});
			self.mapHardList = mapRewardList;
		},
		getSelectTeamList: function() {
			var self = this;
			var teamList = new Array();
			_.forEach(this.teamList, function(unit) {
				let obj = {
					unit_id: unit.unit_id,
					promotion_level: unit.promotion_level,
					rarity: unit.rarity,
					active: false,
					search_area_width: unit.search_area_width,
					uqEq: unit.uqEq,
				};
				teamList.push(obj);
			});

			var filterPosition = this.filterPosition;
			var filterOrder = this.orderDesc ? "desc" : "asc";
			switch (filterPosition) {
				case "search_area_width":
					teamList = _.forEach(this.teamList, function(unit) {
						var thisUnit = _.find(self.$store.getters.getUnitData, ["unit_id", unit.unit_id]);
						if (!thisUnit) {
							return;
						}
						unit.search_area_width = Number(thisUnit.search_area_width);
					});
					teamList = _.orderBy(teamList, ["search_area_width", "promotion_level", "rarity"], [filterOrder, "desc", "desc"]);
					break;
				case "rank":
					teamList = _.orderBy(teamList, ["promotion_level", "rarity"], [filterOrder, "desc"]);
					break;
				case "star":
					teamList = _.orderBy(teamList, ["rarity", "promotion_level"], [filterOrder, "desc"]);
					break;
				case "unique":
					teamList = _.forEach(this.teamList, function(unit) {
						if (unit.uqEq != "" && unit.uqEq) {
							unit.uqEq = Number(unit.uqEq);
						} else {
							unit.uqEq = 0;
						}
					});
					teamList = _.orderBy(teamList, ["uqEq", "promotion_level"], [filterOrder, "desc"]);
					break;
				default:
					teamList = _.orderBy(teamList, ["promotion_level", "rarity"], [filterOrder, "desc"]);
					break;
			}
			this.editTeamList = teamList;
		},
		activeEditList: function(unit_id) {
			var key = _.findKey(this.editTeamList, function(o) {
				return o.unit_id == unit_id;
			});
			if (!key) {
				return;
			}
			var unit = this.editTeamList[key];
			if (!unit) {
				return;
			}
			unit.active = !unit.active;
			this.$set(this.editTeamList, key, unit);
		},				
		unit_equipment: function() {
			var self = this;
			if(self.selectUnit) {
				var nowRank = self.selectUnit.promotion_level;
				var eqList = self.selectUnit.eqList;				
				var selectUnit = _.find(eqList, function(o) {
					return o.promotion_level == nowRank;
				});
				let reOrderUnit = {}
				if(selectUnit) {
					const {unit_id,equip_slot_1,equip_slot_5,equip_slot_4,equip_slot_6,equip_slot_2,equip_slot_3,promotion_level} = selectUnit
					reOrderUnit = {
						unit_id:unit_id,
						promotion_level:promotion_level,
						equip_slot_1:equip_slot_1,
						equip_slot_2:equip_slot_2,
						equip_slot_3:equip_slot_3,
						equip_slot_4:equip_slot_4,
						equip_slot_5:equip_slot_5,
						equip_slot_6:equip_slot_6
					}					
				}				
				return reOrderUnit;
			}
		},
		updateDropRate: function() {
			var self = this;
			this.isLoading = true;
			this.dropRateUpdate = !this.dropRateUpdate;
			if (this.dropRateUpdate) {
				localStorage.setItem("dropRateUpdate", "true");
			} else {
				localStorage.setItem("dropRateUpdate", "false");
			}
			self.$nextTick(() => {
				setTimeout(() => {
					self.getMapList();
				}, 500);
			});
		},
		isOldVersion2019: function() {
			var self = this;
			self.oldVersion2019 = false;
			localStorage.setItem("oldVersion2019", "false");
			// if (self.oldVersion2019) {
			// 	self.oldVersion = true;
			// 	localStorage.setItem("oldVersion2019", "true");
			// 	localStorage.setItem("oldVersion", "true");
			// 	var pureCraft = _.cloneDeep(self.$store.getters.getEquipmentCraft);
			// 	var en = _.forEach(pureCraft, function(o) {
			// 		var obj = _.find(self.equipmentReduce, ["equipment_id", o.equipment_id]);
			// 		if (obj) {
			// 			o.consume_num_1 = obj.consume_num_old;
			// 		}
			// 		let obj19 = _.find(self.equipmentReduce2019, ["equipment_id", o.equipment_id]);
			// 		if (obj19) {
			// 			o.consume_num_1 = obj19.consume_num_old;
			// 		}
			// 	})
			// 	self.equipmentCraft = en;
			// } else {
			// 	self.oldVersion = false;
			// 	localStorage.setItem("oldVersion2019", "false");
			// 	localStorage.setItem("oldVersion", "false");
			// 	self.equipmentCraft = _.cloneDeep(self.$store.getters.getEquipmentCraft);
			// }
		},
		isOldVersion: function() {
			var self = this;
			self.oldVersion = !self.oldVersion;
			if (self.oldVersion) {
				localStorage.setItem("oldVersion", "true");
				var pureCraft = _.cloneDeep(self.$store.getters.getEquipmentCraft);
				var tw = _.forEach(pureCraft, function(o) {
					var obj = _.find(self.equipmentReduce, ["equipment_id", o.equipment_id]);
					if (obj) {
						o.consume_num_1 = obj.consume_num_old;
					}
				});
				self.equipmentCraft = tw;
			} else {
				if (self.oldVersion2019) {
					self.oldVersion2019 = false;
					localStorage.setItem("oldVersion2019", "false");
				}
				localStorage.setItem("oldVersion", "false");
				self.equipmentCraft = _.cloneDeep(self.$store.getters.getEquipmentCraft);
			}
		},
		nowStock: function(item) {
			var stock = _.find(this.itemList, ["equipment_id", Number(item)]);
			if (!stock) {
				return 0;
			}
			return stock.count;
		},
		showSubDropBtn: function() {
			this.showSubDrop = !this.showSubDrop;
		},
		showFastStock: function() {
			this.fastChangeStock = !this.fastChangeStock;
		},
		showFastPluseStock: function() {
			this.fastPluseStock = !this.fastPluseStock;
		},
		mapEditBtn: function() {
			this.mapEdit = !this.mapEdit;
		},
		changeStock: function(count, equipment_id) {
			var key = _.findKey(this.itemList, function(o) {
				return o.equipment_id == equipment_id;
			});
			if (!key) {
				return;
			}
			var item = this.itemList[key];
			if (item.count == count) {
				return;
			}
			item.count = count;
			this.$set(this.itemList, key, item);
		},
		pluseStock: function(event, value, equipment_id) {
			if (Number(value) == 0) {
				return;
			}
			var key = _.findKey(this.itemList, function(o) {
				return o.equipment_id == equipment_id;
			});
			if (!key) {
				return;
			}
			var item = this.itemList[key];
			item.count = Number(item.count) + Number(value);
			event.target.value = "";
			this.$set(this.itemList, key, item);
		},
		questEdit: function(quest) {
			var self = this;
			var currentMap = _.cloneDeep(quest);
			var questDropList = _.forEach(currentMap.quest_drop_item_list, function(item) {
				item["stock"] = self.nowStock(item.reward_id);
				item["plus"] = 0;
			});
			var subDropList = _.forEach(currentMap.subDropItemList, function(item) {
				item["stock"] = self.nowStock(item.eq_craft);
				item["plus"] = 0;
			});
			self.mapTarget = currentMap;
			$("#MapItemBox").modal();
		},
		updateMap: function(quest) {
			var self = this;
			var currentMap = self.mapTarget;
			_.forEach(currentMap.quest_drop_item_list, function(drop) {
				var key = _.findKey(self.itemList, function(o) {
					return o.equipment_id == drop.reward_id;
				});
				if (!key) {
					return;
				}
				var item = self.itemList[key];
				if (Number(item.count) != Number(drop.stock)) {
					item.count = drop.stock;
				}
				if (Number(drop.plus) != 0) {
					item.count = Number(item.count) + Number(drop.plus);
				}
				self.$set(self.itemList, key, item);
			});
			_.forEach(currentMap.subDropItemList, function(drop) {
				var key = _.findKey(self.itemList, function(o) {
					return o.equipment_id == drop.eq_craft;
				});
				if (!key) {
					return;
				}
				var item = self.itemList[key];
				if (Number(item.count) != Number(drop.stock)) {
					item.count = drop.stock;
				}
				if (Number(drop.plus) != 0) {
					item.count = Number(item.count) + Number(drop.plus);
				}
				self.$set(self.itemList, key, item);
			});
			$("#MapItemBox").modal("hide");
		},
		pakoZip: function(str) {
			var binaryString = pako.gzip(str, { to: "string" });
			return btoa(binaryString);
		},
		pakoUnzip: function(b64Data) {
			var strData = atob(b64Data);
			// Convert binary string to character-number array
			var charData = strData.split("").map(function(x) {
				return x.charCodeAt(0);
			});
			// Turn number array into byte-array
			var binData = new Uint8Array(charData);
			// // unzip
			var data = pako.inflate(binData);
			// Convert gunzipped byteArray back to ascii string:
			strData = String.fromCharCode.apply(null, new Uint16Array(data));
			return strData;
		},
		importText: function() {
			var self = this;
			try {
				let importTxt = self.importTxt;
				if (importTxt == null || importTxt == "") {
					return;
				}
				importTxt = importTxt.trim();
				var decodeTxt = JSON.parse(self.pakoUnzip(importTxt));
				var rawTeamList = decodeTxt[0];
				var rawItemList = decodeTxt[1];
				var rawMpList = decodeTxt[2];
				var teamList = [];
				_.forEach(rawTeamList, function(item) {
					var unit_id = parseInt(item.u, 16) + "01";
					var thisUnit = _.find(self.$store.getters.getUnitData, ["unit_id", unit_id]);
					if (!thisUnit) {
						return;
					}
					var thisEquipment = new Array();
					thisEquipment = _.filter(self.$store.getters.getUnitPromotion, function(o) {
						return _.includes(o.unit_id, unit_id);
					});
					_.forEach(thisEquipment, function(o) {
						if (o["equip_slot_1"]["active"] == null) {
							o["equip_slot_1"] = { eq_id: o.equip_slot_1, active: false };
							o["equip_slot_2"] = { eq_id: o.equip_slot_2, active: false };
							o["equip_slot_3"] = { eq_id: o.equip_slot_3, active: false };
							o["equip_slot_4"] = { eq_id: o.equip_slot_4, active: false };
							o["equip_slot_5"] = { eq_id: o.equip_slot_5, active: false };
							o["equip_slot_6"] = { eq_id: o.equip_slot_6, active: false };
						}
					});
					var myUnit = new Object();
					myUnit["eqList"] = thisEquipment;
					var activeList = item.e.split("");
					for (var i = 1; i <= 6; i++) {
						thisEquipment[Number(item.p) - 1]["equip_slot_" + i].active = activeList[i - 1] == "1" ? true : false;
					}
					try {
						myUnit["promotion_level"] = item.p;
						myUnit["rarity"] = item.r;
						myUnit["unit_id"] = thisUnit.unit_id;
						myUnit["trace"] = item.t.toString();
						myUnit["focus"] = item.f;
						myUnit["uqEq"] = item.q;
						myUnit["lvBreak"] = item.b;
						teamList.push(myUnit);
					} catch (e) {
						console.log(e);
					}
				});
				_.forEach(teamList, function(o) {
					try {
						var reSelect = _.find(self.star3, ["id", o.unit_id]);
						if (_.isEmpty(reSelect)) {
							var reSelect = _.find(self.star2, ["id", o.unit_id]);
						}
						if (_.isEmpty(reSelect)) {
							var reSelect = _.find(self.star1, ["id", o.unit_id]);
						}
						reSelect.select = true;

						if (_.isUndefined(o.trace)) {
							o.trace = "true";
						}
					} catch (e) {}
				});
				this.teamList = teamList;
				var itemList = self.itemList;
				var importItemList = _.forEach(rawItemList, function(item) {
					item.e = parseInt(item.e, 16);
					item.c = parseInt(item.c, 16).toString();
				});
				itemList = _.forEach(itemList, function(item) {
					var equipment = _.find(importItemList, ["e", item.equipment_id]);
					if (equipment) {
						item.count = equipment.c;
						item.active = equipment.a;
					}
				});
				self.itemList = itemList;
				if (rawMpList) {
					let mpList = self.memoryPiecesList;
					let importMpList = _.forEach(rawMpList, function(item) {
						item.u = parseInt(item.u, 16).toString();
						item.c = parseInt(item.c, 16);
					});
					_.forEach(mpList, function(item) {
						let mp = _.find(importMpList, ["u", item.unit_id]);
						if (mp) {
							item.count = mp.c;
							//item.active = item.a;
						}
					});
					self.memoryPiecesList = mpList;
				}

				self.$nextTick(() => {
					self.$forceUpdate();
					$("#ImportModal").modal("hide");
					$("#popBox").modal();
					self.popMsg.title = this.$t("Hint");
					self.popMsg.content = this.$t("ImportSuccess");
					self.lzw = "";
					self.importTxt = "";
				});
			} catch (e) {
				console.log(e);
				$("#popBox").modal();
				self.popMsg.title = this.$t("Hint");
				self.popMsg.content = this.$t("ImportFailed");
				//localStorage.getItem("teamList1");
			}
		},
		exportImage: function() {
			html2canvas(document.querySelector("#team-list-box")).then((canvas) => {
				document.body.appendChild(canvas);
			});
		},
		copyText: function(id) {
			var self = this;
			try {
				var TextRange = document.createRange();
				TextRange.selectNode(document.getElementById(id));
				var sel = window.getSelection();
				sel.removeAllRanges();
				sel.addRange(TextRange);
				document.execCommand("copy");
				$("#popBox").modal();

				self.popMsg.title = this.$t("Hint");
				self.popMsg.content = this.$t("CopySuccess");
			} catch (e) {
				console.log(e);
				$("#popBox").modal();
				self.popMsg.title = this.$t("Hint");
				self.popMsg.content = this.$t("CopyFailed");
			}
		},
		zipMyTeam: function() {
			var self = this;
			var myTeam = this.teamList;
			var teamList = [];
			var hasError = "";
			_.forEach(myTeam, function(item) {
				var eq = item.eqList[Number(item.promotion_level) - 1];

				function eqIdToHex(eqObj) {
					function to10(x) {
						if (x == true) {
							return "1";
						} else {
							return "0";
						}
					}
					try {
						var eqTo2 =
							to10(eqObj.equip_slot_1.active) +
							to10(eqObj.equip_slot_2.active) +
							to10(eqObj.equip_slot_3.active) +
							to10(eqObj.equip_slot_4.active) +
							to10(eqObj.equip_slot_5.active) +
							to10(eqObj.equip_slot_6.active);
					} catch (e) {
						return "die";
					}
					return eqTo2;
				}
				var eqj = eqIdToHex(eq);
				if (eqj == "die") {
					hasError = item.unit_id;
					return;
				}
				var trace;
				if (_.isUndefined(item.trace)) {
					trace = "true";
				} else {
					trace = item.trace;
				}

				var obj = {
					e: eqj,
					p: item.promotion_level,
					r: item.rarity,
					u: Number(item.unit_id.slice(0, 4)).toString(16),
					t: item.trace,
					q: item.uqEq,
					b: item.lvBreak,
					f: item.focus,
				};
				teamList.push(obj);
			});
			if (hasError != "") {
				$("#popBox").modal();
				self.popMsg.title = "提示訊息";
				self.popMsg.content = "角色有誤，請移除後再次加入: " + self.getCharaName(hasError);
			}
			var myItem = this.itemList;
			var itemList = [];
			_.forEach(myItem, function(item) {
				var obj = {
					c: Number(item.count).toString(16),
					e: Number(item.equipment_id).toString(16),
					a: item.active ? item.active.toString() : "true",
				};
				itemList.push(obj);
			});
			var myMp = this.memoryPiecesList;
			let mpList = [];
			_.forEach(myMp, function(item) {
				var obj = {
					c: Number(item.count).toString(16),
					u: Number(item.unit_id).toString(16),
				};
				mpList.push(obj);
			});
			var armory = _.concat([teamList], [itemList], [mpList]);
			var toJson = JSON.stringify(armory);
			return self.pakoZip(toJson);
		},
		exportText: function() {
			var self = this;
			self.lzw = self.zipMyTeam();
		},
		transferSaveTeam: function() {
			var self = this;
			if (self.teamList.length != 0) {
				localStorage.setItem("slot1", self.zipMyTeam());
			}
		},
		saveTempTeam: function() {
			var self = this;
			if (self.teamList.length != 0) {
				localStorage.setItem("tempSlot", self.zipMyTeam());
			}
		},
		loadTempTeam: function() {
			var self = this;
			var tempTeam = localStorage.getItem("tempSlot");
			if (tempTeam != "") {
				self.importTxt = tempTeam;
				self.importText();
			}
			self.$nextTick(() => {
				self.isLoading = false;
				localStorage.removeItem("tempSlot");
			});
		},
	},
	created: function() {
		var self = this;
		var ignoreEqRank = localStorage.getItem("ignoreEqRank");
		if (ignoreEqRank == "false" || !ignoreEqRank) {
			ignoreEqRank = false;
		} else {
			ignoreEqRank = true;
		}

		var filterEqRank = localStorage.getItem("filterEqRank");
		if (!filterEqRank) {
			filterEqRank = 104000;
		} else {
			filterEqRank = Number(filterEqRank);
		}

		var autoSubtraction = localStorage.getItem("autoSubtraction");
		if (autoSubtraction == "false" || !autoSubtraction) {
			autoSubtraction = false;
		} else {
			autoSubtraction = true;
		}

		var dropRateUpdate = localStorage.getItem("dropRateUpdate");
		if (dropRateUpdate == "false" || !dropRateUpdate) {
			dropRateUpdate = false;
		} else {
			dropRateUpdate = true;
		}

		var filterPosition = localStorage.getItem("filterPosition");
		if (!filterPosition && filterPosition != "") {
			filterPosition = "rank";
		}

		var orderDesc = localStorage.getItem("orderDesc");
		if (orderDesc == "false" || !orderDesc) {
			orderDesc = false;
		} else {
			orderDesc = true;
		}
		var slotSetting = localStorage.getItem("slotSetting1");
		if (!slotSetting) {
			slotSetting = [{
					id: "Slot1",
					name: "Slot 1",
					active: true,
				},
				{
					id: "Slot2",
					name: "Slot 2",
					active: false,
				},
				{
					id: "Slot3",
					name: "Slot 3",
					active: false,
				},
				{
					id: "Slot4",
					name: "Slot 4",
					active: false,
				},
				{
					id: "Slot5",
					name: "Slot 5",
					active: false,
				},
			];
		} else {
			slotSetting = JSON.parse(localStorage.getItem("slotSetting"));
		}

		self.equipmentCraft = self.$store.getters.getEquipmentCraft;
		var mapTop = localStorage.getItem("mapTop");
		var fastSee = localStorage.getItem("fastSee");
		this.fastSee = fastSee == "true" ? true : false;
		this.filterMapTop = mapTop == null ? "" : mapTop;
		this.ignoreEqRank = ignoreEqRank;
		this.filterEqRank = Number(filterEqRank);
		this.autoSubtraction = autoSubtraction;
		this.slotSetting = slotSetting;
		this.filterPosition = filterPosition;
		this.dropRateUpdate = dropRateUpdate;
		this.orderDesc = orderDesc;
		this.getMapList();
		this.getHardMapList();
	},
	computed: {
		locale() {
			return this.$i18n.locale;
		},
		resourcesList: function() {
			var teamList = _.cloneDeep(this.teamList);
			var uqLevel = UqLevel;
			var uqHeart = this.heartCost;
			var self = this;
			_.forEach(teamList, function(o) {
				var current = Number(o.uqEq);
				var target = Number(self.uqTop);
				var filterUqLevel = _.filter(uqLevel, function(o) {
					return o.uqLevel < target && o.uqLevel >= current;
				});
				var memoSum = _.sumBy(filterUqLevel, "memo");
				if (current == target) {
					memoSum = 0;
				}
				o["memo"] = memoSum;
				var filterUqHeart = _.filter(uqHeart, function(o) {
					return o.lv > current;
				});
				var heartSum = _.sumBy(filterUqHeart, "cost");
				o["heart"] = heartSum;
			});
			return teamList;
		},
		hardDropList: function() {
			var self = this;
			var mapList = self.mapHardList;
			let myEqList = _.cloneDeep(self.myEqList);
			var recipeList = _.cloneDeep(self.recipeList);
			var itemConstraints = {};

			var filterItemList = mapList.reduce(function(arr, item) {
				return arr.concat(item.quest_drop_item_list.map((x) => x.reward_id));
			}, []);
			filterItemList = _.uniq(filterItemList);

			myEqList = _.forEach(recipeList, function(o, v) {
				var myItem = _.find(self.itemList, ["equipment_id", Number(o.eq_craft)]);
				if (o.eq_craft == "103613") {
					myItem = _.find(this.itemList, ["equipment_id", "103611"]);
				}
				if (!myItem) {
					return;
				}
				var lack = Number(o.count) - Number(myItem.count);
				o.count = lack;
				o.stock = myItem.count;
				if (_.includes(filterItemList, o.eq_craft)) {
					itemConstraints[o.eq_craft] = { min: o.count <= 0 ? 0 : o.count };
				}
			});
			var lpParameter = {};
			_.forEach(mapList, function(o) {
				var obj = {};
				obj[o.quest_name.toString()] = { stamina: Number(o.stamina) };
				_.forEach(o.quest_drop_item_list, function(j) {
					var object = {};
					object[j.reward_id] = Number(j.odds) / 100;
					obj[o.quest_name] = _.merge(obj[o.quest_name], object);
				});
				lpParameter = _.merge(obj, lpParameter);
			});
			const model = {
				optimize: "stamina",
				opType: "min",
				constraints: itemConstraints,
				variables: lpParameter,
			};
			var lp_result = Solver.Solve(model);

			var myMap = {};
			myMap = _.forEach(mapList, function(o) {
				_.forEach(o.quest_drop_item_list, function(quest_drop_item) {
					var mapEq = _.find(myEqList, ["eq_id", quest_drop_item.eq_id]);
					if (mapEq) {
						let lack = Number(mapEq.count);
						let stock = mapEq.stock;
						if (mapEq.count <= 0) {
							quest_drop_item["overflow"] = self.$t("Overflow") + Math.abs(mapEq.count);
							quest_drop_item["mapCount"] = 0;
							quest_drop_item["mapWeight"] = 0;
						} else {
							quest_drop_item["mapCount"] = mapEq.count;
							if (mapEq.count == 0 || !mapEq.count) {
								quest_drop_item["mapWeight"] = 0;
								return;
							}
							if (lack <= 0) {
								lack = 1;
							}
							if (lack <= 0) {
								lack = 1;
							}
							quest_drop_item["mapWeight"] = Number(quest_drop_item.odds);
						}
					} else {
						quest_drop_item["mapCount"] = 0;
						quest_drop_item["overflow"] = "無需";
					}
				});
				o["totalMapDrop"] = _.sumBy(o.quest_drop_item_list, "mapCount");
				if (!o["totalMapDrop"]) {
					o["totalMapDrop"] = 0;
				}
				o["totalMapWeight"] = _.sumBy(o.quest_drop_item_list, "mapWeight");
				o["times"] = Number(Math.ceil(lp_result[o.quest_name] ? Number(lp_result[o.quest_name]) : 0));
				o["totalStamina"] = o.stamina * o.times;
			});

			myMap = _.filter(myMap, function(o) {
				return o.totalMapDrop != 0 || o.totalMapDrop != "0";
			});

			self.totalCost = _.sumBy(myMap, "totalStamina");
			myMap = _.orderBy(myMap, ["totalMapWeight", "times"], ["desc", "desc"]);
			myMap.sort((a, b) => (a.times === 0) - (b.times === 0));

			if (!myMap || myMap.length <= 0) {
				self.pageCount = 1;
			} else {
				self.pageCount = parseInt(myMap.length / self.pageSize) + (myMap.length % self.pageSize > 0 ? 1 : 0);
				for (let i = 0; i < myMap.length; i++) {
					self.$set(myMap[i], "page", parseInt(i / self.pageSize) + 1);
				}
			}
			return myMap.filter(function(x) {
				return x.page === self.currentPage;
			});
		},
		mapDropList: function() {
			var self = this;
			var mapList = self.mapList;
			if (self.filterMapTop != "") {
				let mapTopSplit = self.filterMapTop.toString().split(".");
				let mapTop = Number(mapTopSplit[0]);
				mapList = _.filter(mapList, function(o) {
					var area = o.quest_name.split("-");
					if (mapTop >= Number(area[0])) {
						if (mapTopSplit.length > 1 && area[0] >= mapTop) {
							if (Number(area[1]) <= Number(mapTopSplit[1])) {
								return o;
							}
						} else {
							return o;
						}
					}
				});
			}
			if (self.filterMap != "") {
				let mapFilterSplit = self.filterMap.toString().split(".");
				let mapFilter = Number(mapFilterSplit[0]);
				mapList = _.filter(mapList, function(o) {
					var area = o.quest_name.split("-");
					if (mapFilter == area[0]) {
						if (mapFilterSplit.length > 1) {
							if (Number(area[1]) <= Number(mapFilterSplit[1])) {
								return o;
							}
						} else {
							return o;
						}
					}
				});
			}

			if (self.filterEq != "") {
				mapList = _.filter(mapList, function(o) {
					var drop = _.filter(o.quest_drop_item_list, function(j) {
						return j.reward_name.includes(self.filterEq);
					});
					return drop.length > 0;
				});
			}

			if (self.filterEqList.length > 0) {
				self.filterEq = "";
				mapList = mapList.filter(function (map) {				
					return map.quest_drop_item_list.some(function (questItem) {
						return self.filterEqList.includes(questItem.reward_name);
					}) || (map.subDropItemList && map.subDropItemList.some(function (subItem) {
						return self.filterEqList.includes(self.getEqName(subItem.eq_id));
					}));
				});
			}

			let myEqList = _.cloneDeep(self.myEqList);
			var recipeList = _.cloneDeep(self.recipeList);
			var itemConstraints = {};

			var filterItemList = mapList.reduce(function(arr, item) {
				if (item.subDropItemList) {
					return arr.concat(
						item.quest_drop_item_list.map((x) => x.reward_id),
						item.subDropItemList.map((y) => y.eq_craft)
					);
				} else {
					return arr.concat(item.quest_drop_item_list.map((x) => x.reward_id));
				}
			}, []);
			filterItemList = _.uniq(filterItemList);

			myEqList = _.forEach(recipeList, function(o, v) {
				var myItem = _.find(self.itemList, ["equipment_id", Number(o.eq_craft)]);
				if (o.eq_craft == "103613") {
					myItem = _.find(this.itemList, ["equipment_id", "103611"]);
				}
				if (!myItem) {
					return;
				}
				var lack = Number(o.count) - Number(myItem.count);
				o.count = lack;
				o.stock = myItem.count;
				if (_.includes(filterItemList, o.eq_craft)) {
					itemConstraints[o.eq_craft] = { min: o.count <= 0 ? 0 : o.count };
				}
			});
			var lpParameter = {};
			_.forEach(mapList, function(o) {
				var obj = {};
				obj[o.quest_name.toString()] = { stamina: Number(o.stamina) };
				_.forEach(o.quest_drop_item_list, function(j) {
					var object = {};
					object[j.reward_id] = Number(j.odds) / 100;
					obj[o.quest_name] = _.merge(obj[o.quest_name], object);
				});
				if (o.subDropItemList) {
					_.forEach(o.subDropItemList, function(s) {
						var object = {};
						object[s.eq_craft] = Number((100 / o.subDropItemList.length / 100).toFixed(2));
						obj[o.quest_name] = _.merge(obj[o.quest_name], object);
					});
				}
				if (o.quest_drop_item_list.length > 0) {
					lpParameter = _.merge(obj, lpParameter);
				}
			});

			const model = {
				optimize: "stamina",
				opType: "min",
				constraints: itemConstraints,
				variables: lpParameter,
			};
			var lp_result = Solver.Solve(model);

			var myMap = {};
			myMap = _.forEach(mapList, function(o) {
				_.forEach(o.quest_drop_item_list, function(quest_drop_item) {
					var mapEq = _.find(myEqList, ["eq_id", quest_drop_item.eq_id]);
					if (mapEq) {
						let lack = Number(mapEq.count);
						let stock = mapEq.stock;
						if (mapEq.count <= 0) {
							quest_drop_item["overflow"] = self.$t("Overflow") + Math.abs(mapEq.count);
							quest_drop_item["mapCount"] = 0;
							quest_drop_item["mapWeight"] = 0;
						} else {
							quest_drop_item["mapCount"] = mapEq.count;
							if (mapEq.count == 0 || !mapEq.count) {
								quest_drop_item["mapWeight"] = 0;
								return;
							}
							if (lack <= 0) {
								lack = 1;
							}
							if (lack <= 0) {
								lack = 1;
							}
							quest_drop_item["mapWeight"] = Number(quest_drop_item.odds);
						}
					} else {
						quest_drop_item["mapCount"] = 0;
						quest_drop_item["overflow"] = "無需";
					}
				});
				if (o.subDropItemList) {
					_.forEach(o.subDropItemList, function(sub_drop_item) {
						try {
							var mapEq = _.find(myEqList, ["eq_id", sub_drop_item.eq_id]);
							if (mapEq) {
								let lack = Number(mapEq.count);
								let stock = mapEq.stock;
								if (mapEq.count <= 0) {
									sub_drop_item["overflow"] = self.$t("Overflow") + Math.abs(mapEq.count);
									sub_drop_item["mapCount"] = 0;
									sub_drop_item["mapWeight"] = 0;
								} else {
									sub_drop_item["mapCount"] = mapEq.count;
									if (mapEq.count == 0 || !mapEq.count) {
										sub_drop_item["mapWeight"] = 0;
										return;
									}
									if (lack <= 0) {
										lack = 1;
									}
									if (lack <= 0) {
										lack = 1;
									}
									sub_drop_item["mapWeight"] = Number((100 / o.subDropItemList.length).toFixed(2));
								}
							} else {
								sub_drop_item["mapCount"] = 0;
								sub_drop_item["overflow"] = "無需";
							}
						} catch (e) {}
					});
				}

				o["totalMapDrop"] = _.sumBy(o.quest_drop_item_list, "mapCount") + _.sumBy(o.subDropItemList, "mapCount");
				if (!o["totalMapDrop"]) {
					o["totalMapDrop"] = 0;
				}
				o["totalMapWeight"] = _.sumBy(o.quest_drop_item_list, "mapWeight") + _.sumBy(o.subDropItemList, "mapWeight");
				o["times"] = Number(Math.ceil(lp_result[o.quest_name] ? Number(lp_result[o.quest_name]) : 0));
				o["totalStamina"] = o.stamina * o.times;
			});

			myMap = _.filter(myMap, function(o) {
				return o.totalMapDrop != 0 || o.totalMapDrop != "0";
			});

			self.totalCost = _.sumBy(myMap, "totalStamina");
			myMap = _.orderBy(myMap, ["totalMapWeight", "times"], ["desc", "desc"]);
			myMap.sort((a, b) => (a.times === 0) - (b.times === 0));

			if (!myMap || myMap.length <= 0) {
				self.pageCount = 1;
			} else {
				self.pageCount = parseInt(myMap.length / self.pageSize) + (myMap.length % self.pageSize > 0 ? 1 : 0);
				for (let i = 0; i < myMap.length; i++) {
					self.$set(myMap[i], "page", parseInt(i / self.pageSize) + 1);
				}
			}
			return myMap.filter(function(x) {
				return x.page === self.currentPage;
			});
			//return myMap;
		},
		recipeList: function() {
			var self = this;
			var myEqList = this.myEqList;
			var recipeList = [];
			_.forEach(myEqList, function(obj) {
				var eq = _.find(self.equipmentCraft, ["equipment_id", obj.eq_id]);
				if (!eq) {
					return;
				}
				if (eq.condition_equipment_id_1 == "103613") {
					return;
				}
				if (_.inRange(Number(eq.condition_equipment_id_1), 122282, 122615)) {
					return;
				}
				var count = Number(obj.count);
				var item = {
					eq_id: obj.eq_id,
					eq_craft: eq.condition_equipment_id_1,
					count: count * eq.consume_num_1,
					eq_name: obj.eq_name,
					en_eq_name: obj.en_eq_name,
					jp_eq_name: obj.jp_eq_name,
				};
				recipeList.push(item);
			});
			return recipeList;
		},
		myItemList: function() {
			var self = this;
			var itemList = this.itemList;
			_.forEach(itemList, function(o) {
				o.promotion_level = Number(o.promotion_level);
				o.equipment_id = Number(o.equipment_id);
				o.require_level = Number(o.require_level);
				if (_.isEmpty(o.active)) {
					o.active = "1";
				}

				var eq = _.find(self.equipmentCraft, ["condition_equipment_id_1", o.equipment_id.toString()]);
				if (!eq) {
					return;
				}
				o["eq_id"] = Number(eq.equipment_id);
				var eer = _.find(self.$store.getters.getEquipmentEnhanceRate, ["equipment_id", eq.equipment_id]);
				if (!eer) {
					return;
				}
				if (_.some(["配件", "命中", "アクセサリ"], (el) => _.includes(eer.description, el))) {
					o.itemType = 0;
				}
				if (_.some(["頭盔", "帽"], (el) => _.includes(eer.description, el))) {
					o["itemType"] = 1;
				}
				if (_.some(["鞋", "靴"], (el) => _.includes(eer.description, el))) {
					o["itemType"] = 2;
				}
				if (eer.description == "盾") {
					o["itemType"] = 3;
				}
				if (eer.description == "魔法服") {
					o["itemType"] = 4;
				}
				if (_.some(["衣服", "服"], (el) => _.includes(eer.description, el))) {
					o["itemType"] = 5;
				}
				if (_.some(["重型鎧甲", "重装鎧"], (el) => _.includes(eer.description, el))) {
					o["itemType"] = 6;
				}
				if (_.some(["輕型鎧甲", "軽装鎧"], (el) => _.includes(eer.description, el))) {
					o["itemType"] = 7;
				}
				if (eer.description == "回復杖") {
					o["itemType"] = 8;
				}
				if (eer.description == "回復法杖") {
					o["itemType"] = 9;
				}
				if (eer.description == "攻撃杖") {
					o["itemType"] = 10;
				}
				if (eer.description == "攻擊法杖") {
					o["itemType"] = 11;
				}
				if (eer.description == "斧") {
					o["itemType"] = 12;
				}
				if (eer.description == "槍") {
					o["itemType"] = 13;
				}
				if (eer.description == "戟") {
					o["itemType"] = 14;
				}
				if (eer.description == "弓") {
					o["itemType"] = 15;
					if (eer.equipment_id == "105167") {
						o["itemType"] = 13;
					}
				}
				if (_.some(["拳", "指虎"], (el) => _.includes(eer.description, el))) {
					o["itemType"] = 16;
				}
				if (eer.description == "短剣") {
					o["itemType"] = 17;
				}
				if (eer.description == "短劍") {
					o["itemType"] = 18;
				}
				if (eer.description == "刀") {
					o["itemType"] = 19;
				}
				if (eer.description == "劍" || eer.description == "剣") {
					o["itemType"] = 20;
				}
			});

			itemList = _.orderBy(
				itemList,
				["active", "promotion_level", "itemType", "eq_id", "require_level"],
				["desc", "desc", "asc", "desc", "desc"]
			);
			return itemList;
		},
		myList: function() {
			var self = this;
			var teamList = _.forEach(this.teamList, function(unit) {
				unit.promotion_level = Number(unit.promotion_level);
			});
			var filterPosition = this.filterPosition;
			var filterOrder = this.orderDesc ? "desc" : "asc";
			switch (filterPosition) {
				case "front":
					teamList = _.forEach(this.teamList, function(unit) {
						var thisUnit = _.find(self.$store.getters.getUnitData, ["unit_id", unit.unit_id]);
						if (!thisUnit) {
							return;
						}
						unit.search_area_width = Number(thisUnit.search_area_width);
					});
					teamList = _.orderBy(
						_.filter(teamList, function(o) {
							let p = Number(o.search_area_width);
							return p < 300;
						}),
						["search_area_width", "unit_id"],
						[filterOrder, filterOrder]
					);
					break;
				case "middle":
					teamList = _.forEach(this.teamList, function(unit) {
						var thisUnit = _.find(self.$store.getters.getUnitData, ["unit_id", unit.unit_id]);
						if (!thisUnit) {
							return;
						}
						unit.search_area_width = Number(thisUnit.search_area_width);
					});
					teamList = _.orderBy(
						_.filter(teamList, function(o) {
							let p = Number(o.search_area_width);
							return p < 600 && p > 300;
						}),
						["search_area_width", "unit_id"],
						[filterOrder, filterOrder]
					);
					break;
				case "back":
					teamList = _.forEach(this.teamList, function(unit) {
						var thisUnit = _.find(self.$store.getters.getUnitData, ["unit_id", unit.unit_id]);
						if (!thisUnit) {
							return;
						}
						unit.search_area_width = Number(thisUnit.search_area_width);
					});
					teamList = _.orderBy(
						_.filter(teamList, function(o) {
							let p = Number(o.search_area_width);
							return p < 900 && p > 600;
						}),
						["search_area_width", "unit_id"],
						[filterOrder, filterOrder]
					);
					break;
				case "search_area_width":
					teamList = _.forEach(this.teamList, function(unit) {
						var thisUnit = _.find(self.$store.getters.getUnitData, ["unit_id", unit.unit_id]);
						if (!thisUnit) {
							return;
						}
						unit.search_area_width = Number(thisUnit.search_area_width);
					});
					teamList = _.orderBy(teamList, ["search_area_width", "unit_id"], [filterOrder, filterOrder]);
					break;
				case "rank":
					teamList = _.orderBy(teamList, ["promotion_level", "rarity"], [filterOrder, "desc"]);
					break;
				case "star":
					teamList = _.orderBy(teamList, ["rarity", "promotion_level"], [filterOrder, "desc"]);
					break;
				case "unique":
					teamList = _.forEach(this.teamList, function(unit) {
						if (unit.uqEq != "" && unit.uqEq) {
							unit.uqEq = Number(unit.uqEq);
						} else {
							unit.uqEq = 0;
						}
					});
					teamList = _.orderBy(teamList, ["uqEq", "promotion_level"], [filterOrder, "desc"]);
					break;
				default:
					teamList = _.orderBy(teamList, ["promotion_level", "rarity"], [filterOrder, "desc"]);
					break;
			}

			teamList = _.sortBy(teamList, function(item) {
				return item.trace == "false" ? 1 : 0;
			});

			return teamList;
		},
		myEqList: function() {
			var self = this;
			var equipmentList = new Array();
			var teamList = self.teamList;
			var topLv = self.promotion_level_top.toString();
			teamList = _.filter(teamList, function(o) {
				var isTrace;
				var rankNow = Number(o.promotion_level);
				var traceLv = o.trace.toString();
				if (traceLv == "true") {
					traceLv = topLv;
				}
				var checkTraceLevel = traceLv.split(".");
				traceLv = Number(traceLv);
				if (_.isEmpty(checkTraceLevel[1])) {
					_.forEach(o.eqList, function(value, key) {
						if (key + 1 < rankNow) {
							for (var i = 1; i <= 6; i++) {
								value["equip_slot_" + i]["active"] = true;
							}
						} else if (key + 1 > rankNow && rankNow <= traceLv && key + 1 <= traceLv) {
							for (var i = 1; i <= 6; i++) {
								value["equip_slot_" + i]["active"] = false;
							}
						} else if (key + 1 > traceLv) {
							for (var i = 1; i <= 6; i++) {
								value["equip_slot_" + i]["active"] = true;
							}
						}
					});
				} else {
					traceLv = Number(checkTraceLevel[0]);
					_.forEach(o.eqList, function(value, key) {
						if (key + 1 < rankNow) {
							for (var i = 1; i <= 6; i++) {
								value["equip_slot_" + i]["active"] = true;
							}
						} else if (key + 1 > rankNow && rankNow <= traceLv && key + 1 <= traceLv) {
							for (var i = 1; i <= 6; i++) {
								value["equip_slot_" + i]["active"] = false;
							}
						} else if (key + 1 > traceLv) {
							for (var i = 1; i <= 6; i++) {
								value["equip_slot_" + i]["active"] = true;
							}
						}
						if (key + 1 == traceLv) {
							if (checkTraceLevel[1] == "3") {
								value["equip_slot_1"]["active"] = true;
								value["equip_slot_3"]["active"] = true;
								value["equip_slot_5"]["active"] = true;
							} else if (checkTraceLevel[1] == "4") {
								value["equip_slot_1"]["active"] = true;
								value["equip_slot_3"]["active"] = true;
							} else if (checkTraceLevel[1] == "5") {
								value["equip_slot_1"]["active"] = true;
							} else if (checkTraceLevel[1] == "0") {
								value["equip_slot_1"]["active"] = true;
								value["equip_slot_2"]["active"] = true;
								value["equip_slot_3"]["active"] = true;
								value["equip_slot_4"]["active"] = true;
								value["equip_slot_5"]["active"] = true;
								value["equip_slot_6"]["active"] = true;
							}
						}
					});
				}

				if (self.displayMode == 9) {
					if (o.trace.toString() != "false" && o.focus) {
						return o;
					}
				} else {
					if (o.trace.toString() != "false") {
						return o;
					}
				}
				return;
			});
			var heartCostList = this.heartCost;
			_.forEach(teamList, function(unit) {
				_.forEach(unit.eqList, function(eq) {
					for (var i = 1; i <= 6; i++) {
						if (eq["equip_slot_" + i].active == false) {
							eq["equip_slot_" + i].unit = unit.unit_id;
							eq["equip_slot_" + i].rank = eq.promotion_level;
							equipmentList.push(eq["equip_slot_" + i]);
						}
					}
				});
				var current = Number(unit.uqEq);
				var filterUqHeart = _.filter(heartCostList, function(o) {
					return o.lv > current;
				});
				var heart = 0;
				var heartSum = _.sumBy(filterUqHeart, "cost");
				heart = heartSum;
				if (heart != 0) {
					var obj = {
						unit: unit.unit_id,
						eq_id: "140001",
						heart: heart,
					};
					equipmentList.push(obj);
				}
			});
			equipmentList = _.groupBy(equipmentList, "eq_id");
			_.forEach(equipmentList, function(value, key) {
				var eq = _.find(self.equipmentCraft, ["equipment_id", key]);
				if (!eq) {
					return;
				}
				var subEq = self.findSubEq(key);
				//var subEq = self.getSubEqList(eq);
				if (!_.isEmpty(subEq)) {
					equipmentList = self.getSubEquipment(equipmentList, subEq, key);
				}
			});
			var eqList = new Array();
			_.forEach(equipmentList, function(o, key) {
				var myEq = new Object();
				if (key == "140001") {
					_.forEach(o, function(h) {
						h.heart = Number(h.heart);
					});
					myEq["count"] = _.sumBy(o, "heart");
				} else {
					myEq["count"] = o.length;
				}
				var unitList = _.map(o, "unit");
				var name = self.findName(key);
				myEq["eq_id"] = key;
				myEq["eq_name"] = name.equipment_name;
				myEq["en_eq_name"] = name.en_equipment_name;
				myEq["jp_eq_name"] = name.jp_equipment_name;
				myEq["unit"] = unitList;
				eqList.push(myEq);
			});
			if (self.filterEqRank != 100000) {
				eqList = _.filter(eqList, function(o) {
					return Number(o.eq_id) > Number(self.filterEqRank);
				});
			}
			eqList = _.filter(eqList, function(o) {
				return o.eq_id != "999999";
			});
			eqList = _.reverse(eqList);
			return eqList;
		},
		myMpList: function() {
			let self = this;
			let teamList = _.cloneDeep(this.teamList);
			let uqLevel = UqLevel;
			let uqHeart = this.heartCost;
			let mpList = this.memoryPiecesList;
			let pool = GachaPool;
			let m40List = _.concat(GachaPool["fes"], GachaPool["limited"], GachaPool["season"]);
			_.forEach(teamList, function(o) {
				let current = Number(o.uqEq);
				let target = Number(self.uqTop);
				let m40 = false;
				if (_.includes(m40List, o.unit_id)) {
					m40 = true;
				}
				var unit = _.find(mpList, ["unit_id", o.unit_id]);
				let filterUqLevel = _.filter(uqLevel, function(o) {
					return o.uqLevel < target && o.uqLevel >= current;
				});
				let memoSum = _.sumBy(filterUqLevel, "memo");
				if (current == target) {
					memoSum = 0;
				}
				//unit["memo"] = memoSum;
				let filterUqHeart = _.filter(uqHeart, function(u) {
					return u.lv > current;
				});
				let heartSum = _.sumBy(filterUqHeart, "cost");
				//unit["heart"] = heartSum;
				unit.heart = heartSum ? heartSum : 0;
				unit.memo = memoSum ? memoSum : 0;
				if (o.lvBreak && o.lvBreak.toString() == "true") {
					unit.lbMemo = 0;
				} else {
					if (m40) {
						unit.lbMemo = 40;
					} else {
						unit.lbMemo = 120;
					}
				}
				unit.total = memoSum + unit.lbMemo;
				unit.uqEq = o.uqEq;
				unit.promotion_level = o.promotion_level;
				unit.rarity = o.rarity;
				mpList[_.findIndex(mpList, ["unit_id", o.unit_id])] = unit;
			});
			mpList = _.orderBy(mpList, ["count", "unit_id"], ["desc", "asc"]);
			return mpList;
		},
		totalMp: function() {
			let total = _.sumBy(this.myMpList, function(o) {
				if (o.count) {
					return o.count;
				}
			});
			return (total = total ? total : 0);
		},
		totalMpRest: function() {
			let total = _.sumBy(this.myMpList, function(o) {
				let c = 0;
				if (o.count) {
					c = o.count;
				}
				let t = 0;
				if (o.total) {
					t = o.total;
				}
				let i = Number(c) - Number(t);
				return i > 0 ? o.count : 0;
			});
			return total ? total : 0;
		},
		totalLack: function() {
			var l = 3000 - this.totalMpRest;
			return l > 0 ? l : 0;
		},
		slotName: function() {
			var currentSlot = this.currentSlot;
			return _.find(this.slotSetting, ["id", currentSlot]).name;
		},
		tempSlotName: function() {
			return this.tempSlot.name;
		},
	},
	destroyed() {
		this.saveTempTeam();
	},
	mounted: function() {
		var self = this;
		for (var i = 1; i <= 3; i++) {
			self.getStarList(i);
		}
		self.getItemList();
		if (typeof Storage === "undefined") {
			self.notSupport = true;
		}
		var uuid = self.$route.query.s;
		if (localStorage.getItem("teamList") != null || !_.isEmpty(uuid)) {
			self.isLoading = true;
			self.loadTeam();
			self.$nextTick(() => {
				self.isLoading = false;
			});
		}
		if (localStorage.getItem("itemList") != null) {
			if (localStorage.getItem("itemList") == "null") {
				self.getItemList();
				return;
			}
			self.loadItem();
		}
		var isOldVersion = localStorage.getItem("oldVersion");
		if (isOldVersion == "true") {
			this.isOldVersion();
		}
		var isOldVersion2019 = localStorage.getItem("oldVersion2019");
		if (isOldVersion2019) {
			this.isOldVersion2019();
		}

		if (localStorage.getItem("tempSlot") && localStorage.getItem("slot1") != localStorage.getItem("tempSlot")) {
			$("#LoadTempTeam").modal();
		}

		$(window).scroll(function() {
			if ($(this).scrollTop() >= 500) {
				$("#scroll-fixed-bottom").fadeIn(200);
			} else {
				$("#scroll-fixed-bottom").fadeOut(200);
			}
		});
		self.getMPList();
		this.transferSaveTeam();
	},
};
</script>
<style scoped>
.font-small {
	font-size: 13px;
	font-family: "新細明體";
}

.expand-enter-active,
.expand-leave-active {
	transition: height 0.2s ease-in-out;
	overflow: hidden;
	transition-property: opacity, height;
}

.expand-enter,
.expand-leave-to {
	height: 0;
	opacity: 0;
}

.armory-box-show-name {
	min-width: 150px;
	margin-bottom: 15px;
}
</style>